/*!
 *  (c)(r) 2008-2023 IT-Service Robert Frunzke
 */

import { sprintf } from '../vendor/sprintf.js';
import { clip, htmlspecialchars, mjRegisterSimpleJQueryPlugin, split_once, toggleMultipleClasses0, mj_deep_extend } from './util.js';
import { default_ajax_app_error_handler } from './fetch-util.js';
import { startProgress, stopProgress } from './progress-util.js';
import { getFromSession, setInSession } from './session-util.js';
import { mj } from './page-mj.js';
import { jQuery } from '../other/jquery-hooked.js';
import { mjt } from './i18ntexts.js';

import { update_common_hooks } from './oc-container-compat.js';
import { scrollElementIntoView } from './dialog-util.js';

import { diff as htmldiff } from '../vendor/htmldiff.js';
import { MDColorUtil } from './color.js';
import { MDMedia } from './media-data.js';
import { MTemplates } from './templates.js';
import { MVBoxCords } from './box-coords.js';
import { MPreviewUtil } from './media-preview-util.js';
import { MVMediaMetadata } from './media-data-view.js';

import { delete_media } from './media-page-actions.js';

import { MDLocale } from './locale-impl.js';
import { mjWidgetOverlayEditor } from './widget-overlay-editor.js';


export let MVCompare = function($,mj) {

	var m_dlg_id = 'mv-compare-form',
		m_dlg=null, m_dlg_tabs=null, m_dlg_menu=null, m_dlg_mid=null, m_dlg_left=null, m_dlg_sciv=null, m_dlg_scedv=null, m_dlg_ddv=null, m_dlg_rdv=null, m_dlg_right=null, m_dlg_overlays=null,
		m_dlg_w=600, m_dlg_h=500;

	var m_media_id_A=null;
	// var m_page_A=1;
	var m_version_A=null, m_dtinfo_A=null, m_dim_A=null;

	var m_media_id_B=null;
	// var m_page_B=1;
	var m_version_B=null, m_dtinfo_B=null, m_dim_B=null;

	var m_mode = 'side-by-side';
	var m_contents_mode_enabled = false;

	var m_opacity = 0.6,
		m_distance_function = 'RGB3',		// RGB0 (manhattan distance), RGB1..RGB3 (euclidian distance, variations, quick & dirty), deltaE_CIE76, deltaE_CIE94
		m_distance_tolerance = 9.5,
		m_highlight_color = '#FF00FF',
		m_highlight_alpha = 0.8,
		m_diff_mask_mode = 'A-B-hl-mask', // "A-B-hl-mask", "highlight1", "highlight3", "mask", "abs-mask" or "blend"
		m_diff_swap_AB = false,
		m_distances_arr = null;

	var m_px2px_status_text = '';

	var m_zoom_area = null;

	var m_site_differences = {};
	var m_site_comparing_actual_site = 0;
	var m_show_site_difference_select = false;

	var m_options; // see init()

	var m_option_values = {};

	var m_last_ajax_request = null;
	var m_last_callback_request = null;

	var m_prev_dd_edi = null;
	var m_prev_dd_x = null;




	function _create_gfxstate_elem( gfxstate, linebreak ) {
		// TODO ... details of gfxstate for display
		var node = $( '<div/>', { 'class':'gfxstate' } )
			.text( gfxstate + (linebreak||'') );
		return node;
	}
	function _create_content_elem( content, linebreak ) {
		// TODO ... details of content for display
		var node = $( '<div/>', { 'class':'content' } )
			.text( content + (linebreak||'') );
		return node;
	}


	function _create_bbox_text( bbox ) {
		// bbox for display ...
		// order of elements in bbox is: llx,lly,urx,ury
		var ta = [];
		ta.push( 'llx='+MDLocale.fmt_float_plain(bbox[0],5) );
		ta.push( 'lly='+MDLocale.fmt_float_plain(bbox[1],5) );
		ta.push( 'urx='+MDLocale.fmt_float_plain(bbox[2],5) );
		ta.push( 'ury='+MDLocale.fmt_float_plain(bbox[3],5) );
		ta.push( 'w='+MDLocale.fmt_float_plain(Math.abs(bbox[2]-bbox[0]),5) );
		ta.push( 'h='+MDLocale.fmt_float_plain(Math.abs(bbox[3]-bbox[1]),5) );
		return ta.join(', ');
	}

	function _create_bbox_elem( bbox, linebreak ) {
		// bbox for display ...
		// order of elements in bbox is: llx,lly,urx,ury
		var node = $( '<span/>', { 'class':'bbox' } )
			.text( _create_bbox_text(bbox) + (linebreak||'') );
		return node;
	}

	function _create_diff_details_elem( ed, linebreak ) {
		var $details = $( '<div/>', { 'class':'details' } );
		$( '<div/>', { 'class':'diff_type' } ).text(ed.d+(linebreak||'')).appendTo($details);
		if( ed.d!='B' ) {
			let $bbox_a = $( '<div/>', { 'class':'bbox_a' } )
				.append('<label>bbox A</label>')
				.append(_create_bbox_elem(ed.bbox_a,linebreak));
			$bbox_a.appendTo($details);
			let $debug_a = $('<div class="debug_a"><label>A</label></div>')
				.append(_create_gfxstate_elem(ed.gfx_state_a,linebreak))
				.append(_create_content_elem(ed.content_a,linebreak));
			$debug_a.appendTo($details);
		}
		if( ed.d!='A' ) {
			let $bbox_b = $( '<div/>', { 'class':'bbox_b' } )
				.append('<label>bbox B</label>')
				.append(_create_bbox_elem(ed.bbox_b,linebreak));
			$bbox_b.appendTo($details);
			let $debug_b = $('<div class="debug_b"><label>B</label></div>')
				.append(_create_gfxstate_elem(ed.gfx_state_b,linebreak))
				.append(_create_content_elem(ed.content_b,linebreak));
			$debug_b.appendTo($details);
		}
		return $details;
	}

	function _get_diff_details_elem( elemIdx, ed ) {
		let result = {
			type: ed.t,
			diff_type: ed.d,
			idx: elemIdx,
		};
		if( ed.d!='B' ) {
			result.a = {
				idx: elemIdx,
				side: 'A',
				type: ed.t,
				doi: ed.doi_a,
				bbox: _create_bbox_text(ed.bbox_a),
				gfx_state: ed.gfx_state_diff_a ?? ed.gfx_state_a,
				content: ed.content_a,
			};
		}
		if( ed.d!='A' ) {
			result.b = {
				idx: elemIdx,
				side: 'B',
				type: ed.t,
				doi: ed.doi_b,
				bbox: _create_bbox_text(ed.bbox_b),
				gfx_state: ed.gfx_state_diff_b ?? ed.gfx_state_b,
				content: ed.content_b,
			};
		}
		return result;
	}

	function text4htmldiff( text ) {
		return htmlspecialchars(text,false,true);
	}

	function diff_details_html( lft, rgt ) {

		const lft_html = {
			idx: sprintf('%5d %s',lft.idx+1,lft.side),
			bbox: text4htmldiff(lft.bbox),
			gfx_state: text4htmldiff(lft.gfx_state),
			content: text4htmldiff(lft.content),
		};

		const rgt_html = {
			idx: sprintf('%5d %s',rgt.idx+1,rgt.side),
			bbox: text4htmldiff(rgt.bbox),
			gfx_state: text4htmldiff(rgt.gfx_state),
			content: text4htmldiff(rgt.content),
		};

		// console.log({j:JSON.stringify({l:lft_html.content,r:rgt_html.content})});

		var _append = function( attrName, cntrClass, labelText ) {
			let $cntr = $( '<div/>', { 'class':cntrClass } );
			$('<label/>').text(labelText).appendTo($cntr);
			$('<div class="lft">'+lft_html[attrName]+'</div>').appendTo($cntr);
			$('<div class="dff">'+htmldiff(lft_html[attrName],rgt_html[attrName])+'</div>').appendTo($cntr);
			$('<div class="rgt">'+rgt_html[attrName]+'</div>').appendTo($cntr);
			return $cntr;
		};

		var $diff = $( '<div/>', { 'class':'diff' } );
		$diff.append( _append('idx','idx','Index') );
		$diff.append( _append('bbox','bbox','BBox') );
		$diff.append( _append('content','content','Content') );
		$diff.append( _append('gfx_state','gfxstate','GfxState') );

		return $diff;
	}


	function _create_site_diff( j, page, pd_key ) {
		var ndiffs = parseInt(j.page_diffs[pd_key].ndifferences);
		var textDiffs;
		if( ndiffs===0 ) textDiffs = mjt('mv-compare-mode-complete-contents-diff-0');
		else if( ndiffs===1 ) textDiffs = mjt('mv-compare-mode-complete-contents-diff-1');
		else textDiffs = mjt('mv-compare-mode-complete-contents-diff-n').replace('%1',ndiffs);
		var textPage = mjt('mv-compare-mode-complete-contents-diff-page').replace('%1',page);
		var textCombined = mjt('mv-compare-mode-complete-contents-diff-combined').replace('%1',textPage).replace('%2',textDiffs);
		return { page:page, ndiffs:ndiffs, inselect:true, textPage:textPage, textDiffs:textDiffs, textCombined:textCombined, result:j };
	}


	function reset( save_session ) {
		if( save_session ) setInSession('compare_item_A','');
		m_media_id_A = null;
		// m_page_A = 1;
		m_version_A = null;
		m_dtinfo_A = null;
		m_dim_A = null;
		m_media_id_B = null;
		// m_page_B = 1;
		m_version_B = null;
		m_dtinfo_B = null;
		m_dim_B = null;
		m_zoom_area = null;
		m_site_differences = {};
		m_site_comparing_actual_site = 0;
		m_option_values = {};
		$('#mv-compare-info').remove();
	}

	function updateIndicatorView( save_session ) {
		$('#mv-compare-info').remove();
		if( m_media_id_A && m_media_id_B===null ) {
			var text = 'ID: '+m_media_id_A;
			if( m_version_A ) text += ' (version '+m_version_A+')';
			if( save_session ) setInSession('compare_item_A',m_media_id_A+':'+(m_version_A?m_version_A:''));
			$('<div id="mv-compare-info"><label>'+mjt('mv-compare-stored')+'</label><div class="first-item"></div><div class="further-steps">'+mjt('mv-compare-stored-further-steps')+'</div></div>')
				.children('.first-item')
				.text(text)
				.click( function() {
					reset(true);
				} )
				.end()
				.appendTo('body');
		} else if( save_session ) {
			setInSession('compare_item_A','');
		}
	}

	// helper function
	function _object_empty( obj ) {
		for( var key in obj ) {
			if( Object.prototype.hasOwnProperty.call(obj,key) ) return false;
		}
		return true;
	}

	function _get_pi_from_meta( dtinfo ) {
		var npages = 1, npages_actually_unknown = false;
		if( dtinfo.meta[501] && dtinfo.meta[501][0] ) npages = parseInt(dtinfo.meta[501][0],10);							// MSD_TEXT_PAGE_COUNT
		if( dtinfo.meta[227] && parseInt(dtinfo.meta[227][0],10)>npages ) npages = parseInt(dtinfo.meta[227][0],10);		// MSD_IMAGE_PAGE_COUNT
		if( dtinfo.meta[236] && parseInt(dtinfo.meta[236][0],10)>npages ) {
			npages = parseInt(dtinfo.meta[236][0],10);																		// MSD_IMAGE_AVAILABLE_PREVIEW_PAGES_COUNT
			npages_actually_unknown = true;
		}
		if( npages < 1 ) npages = 1;
		return [ npages, npages_actually_unknown ];
	}

	function _get_dim_from_meta( dtinfo ) {
		var w = dtinfo.meta[200] ? parseInt(dtinfo.meta[200][0],10) : 0,
			h = dtinfo.meta[201] ? parseInt(dtinfo.meta[201][0],10) : 0,
			r = dtinfo.meta[229] ? parseInt(dtinfo.meta[229][0],10) : 0,
			//cpi = dtinfo.meta.hasOwnProperty('234') ? parseInt(dtinfo.meta[234][0],10) : -1,
			t = dtinfo.meta[235] ? parseInt(dtinfo.meta[235][0],10) : 0,
			//a = dtinfo.meta[230] ? 1.0/parseFloat(dtinfo.meta[230][0]) : 1; // NOTE: this value is unreliable, due to bugs in manja < 3.3
			a = dtinfo.meta[223] ? 1.0/parseFloat(dtinfo.meta[223][0]) : 1,
			b = dtinfo.meta[238] && dtinfo.meta[238][0] ? dtinfo.meta[238][0] : '';
		if( r==90 || r==270 ) return [ h,w, r,t, 1.0/a, b ]; // swap width & height, rotate aspect ratio
		return [ w,h, r,t, a, b ];
	}

	// function _get_avl_boxes_from_meta( dtinfo ) {
	//	return dtinfo.meta[239] && dtinfo.meta[239].length ? ['MediaBox',...dtinfo.meta[239]] : ['MediaBox'];
	// 	return dtinfo.meta[239] && dtinfo.meta[239].length ? ['MediaBox'].concat(dtinfo.meta[239]) : ['MediaBox'];
	// }

	function _nearly_equal_aspect( a, b ) {
		return Math.abs(a-b) < 0.08;// 0.005;
	}

	function _compute_dlg_dimensions() {
		var win = $(window);
		m_dlg_w = Math.min( Math.max( win.width()-10,740), 4*1700 );
		m_dlg_h = Math.min( Math.max(win.height()-10,250), 4*1200 );
	}

	function _cleanup_mode() {
		m_dlg_mid.mjImageZoomWidget('destroy').mjMediaPageNavWidget('destroy').off('.mjMVCompare').empty();

		m_dlg_right.hide().children('.canvas').off('.mjMVCompare').mjMVComparePreview('destroy').empty();
		m_dlg_right.children('.toolbar').empty();
		m_dlg_left.hide().children('.canvas').off('.mjMVCompare').mjMVComparePreview('destroy').empty();
		m_dlg_left.children('.toolbar').empty();

		m_dlg_sciv.hide().empty();
		m_dlg_scedv.hide().empty();
		m_dlg_ddv.hide().empty();
		m_dlg_rdv.empty();
		m_dlg_mid.off('.mjMVCompare').hide().empty();
		m_dlg_overlays.hide().empty();
		m_dlg_menu
			.hide()
			.find('.ctrls2').empty().end()
			.find('.status').empty().end();
	}

	function _destroy_dlg() {
		$(document).off('.mjMVCompare');
		if( m_dlg ) {
			_cleanup_mode();
			m_prev_dd_edi = null;
			m_prev_dd_x = null;
			m_dlg_right = m_dlg_sciv = m_dlg_scedv = m_dlg_ddv = m_dlg_rdv = m_dlg_left = m_dlg_mid = m_dlg_overlays = null;
			m_dlg_tabs.mjDialogTabs('destroy');
			m_dlg_tabs = null;
			m_dlg_menu = null;
			m_site_differences = null;
			$(document).off('mjswinresize.mjMVCompare');
			m_dlg.dialog('destroy');
			m_dlg = null;
		}
	}

	function _dlg_resize_handler( trigger ) {
		var view_w = m_dlg.innerWidth(),
			ddv_w = Math.min( Math.max( Math.round(2.5*view_w/7), 200 ), 700 ),
			pane_w = Math.max( Math.round((view_w-ddv_w)/2-6), 40 ),
			mid_l = pane_w + 2,
			mid_r = pane_w + 2 + 1,
			offs_top =	  ( m_dlg.prev('.ui-dialog-titlebar').innerHeight() )
						+ ( m_dlg_menu.is(':visible') ? m_dlg_menu.innerHeight() : 0 ),
			sciv_h = m_dlg_sciv.is(':visible') ? m_dlg_sciv.innerHeight() : 26;

		m_dlg_left.css(		 { top:(offs_top  )+'px',														width:(pane_w)+'px' } );
		m_dlg_sciv.css(		 { top:(offs_top  )+'px',			left:(mid_l)+'px',	right:(mid_r)+'px'                          } );
		m_dlg_scedv.css(	 { top:(offs_top+sciv_h)+'px',		left:(mid_l)+'px',	right:(mid_r)+'px'                          } );
		m_dlg_ddv.css(		 { top:(offs_top  )+'px',			left:(mid_l)+'px',	right:(mid_r)+'px'                          } );
		m_dlg_right.css(	 { top:(offs_top  )+'px',														width:(pane_w)+'px' } );
		m_dlg_overlays.css(	 { top:(offs_top  )+'px' } );

		if( trigger ) {
			var cv_A = m_dlg_left.children('.canvas');
			cv_A.triggerHandler( 'mjsresize', [cv_A.innerWidth(),cv_A.innerHeight()] );
			var cv_B = m_dlg_right.children('.canvas');
			cv_B.triggerHandler( 'mjsresize', [cv_B.innerWidth(),cv_B.innerHeight()] );
			m_dlg_mid.triggerHandler( 'mjsresize', [m_dlg_mid.width(),m_dlg_mid.height()] );
		}
	}

	function _setup_dlg() {
		_destroy_dlg();

		m_dlg = $('#'+m_dlg_id);
		m_dlg_menu = $('#'+m_dlg_id+'-menu');
		m_dlg_mid = $('#'+m_dlg_id+'-mid');
		m_dlg_left = $('#'+m_dlg_id+'-left');
		m_dlg_left.children('.data').html( mjt('mv-compare-id')+' '+m_media_id_A+' '+( m_dtinfo_A.is_latest_version ? mjt('mv-compare-version-latest') : mjt('mv-compare-version').replace('%1',m_version_A) ) );
		m_dlg_sciv = $('#'+m_dlg_id+'-sciv');
		m_dlg_scedv = $('#'+m_dlg_id+'-scedv');
		m_dlg_ddv = $('#'+m_dlg_id+'-ddv');
		m_dlg_rdv = $('#'+m_dlg_id+'-rdv');
		m_dlg_right = $('#'+m_dlg_id+'-right');
		m_dlg_right.children('.data').html( mjt('mv-compare-id')+' '+m_media_id_B+' '+( m_dtinfo_B.is_latest_version ? mjt('mv-compare-version-latest') : mjt('mv-compare-version').replace('%1',m_version_B) ) );
		m_dlg_overlays = $('#'+m_dlg_id+'-overlays');

		_compute_dlg_dimensions();
		m_dlg.dialog( { width:m_dlg_w, height:m_dlg_h, modal:true, resizable:false, close:function(ev,ui) {
			_destroy_dlg();
			reset(false);
		} } );
		_dlg_resize_handler(true);
		$(document)
			.off('mjswinresize.mjMVCompare')
			.on('mjswinresize.mjMVCompare', $.debounce( 250, function(evt,w,h) {
				if( m_dlg!=null ) {
					_compute_dlg_dimensions();
					m_dlg.dialog('option',{'width':m_dlg_w,'height':m_dlg_h});
					_dlg_resize_handler(true);
				}
			} ) );

	}

	function parseCompleteDocument( start_page, ondone ) {
		if( _object_empty(m_option_values) ) {
			for( var opt_name in m_options ) {
				if( !m_options.hasOwnProperty(opt_name) ) continue;
				m_option_values[opt_name] = m_options[opt_name].def;
			}
		}
		m_site_differences = {};
		var page_count_A = m_dtinfo_A.meta[501] ? m_dtinfo_A.meta[501][0] : 1,
			page_count_B = m_dtinfo_B.meta[501] ? m_dtinfo_B.meta[501][0] : 1;
		var use_clip_path_A = m_dtinfo_A.meta[234] ? parseInt(m_dtinfo_A.meta[234][0],10) : -1,
			use_clip_path_B = m_dtinfo_B.meta[234] ? parseInt(m_dtinfo_B.meta[234][0],10) : -1;
		var use_box_A = m_dtinfo_A.meta[238] ? m_dtinfo_A.meta[238][0] : '',
			use_box_B = m_dtinfo_B.meta[238] ? m_dtinfo_B.meta[238][0] : '';

		var _load_data = function( page, ondone ) {
			if( m_dlg_ddv===null ) return; // canceled (dialog was closed)
			if( m_site_differences===null ) return;
			var pd_key = (page)+':'+(page);
			if( m_site_differences.hasOwnProperty(pd_key) ) {
				// result already exists ...
				if( page+1 <= Math.min(page_count_A,page_count_B) ) {
					// skip to next page
					_load_data(page+1,ondone);
				}
				return;
			}
			if( m_mode == 'side-by-side' ) {
				var elem = m_dlg_ddv.find('.compare_contents').children('tr[data-page="'+page+'"]').children('td');
				elem.addClass('loading');
			}
			m_site_comparing_actual_site = page;
			if( m_last_callback_request!==null && m_last_callback_request.state && m_last_callback_request.state()==='pending' ) {
				m_last_callback_request.abort();
				m_last_callback_request = null;
			}
			var postdata = {
				media_id_a:m_media_id_A, page_a:page, clip_path_a:use_clip_path_A, box_a:use_box_A, version_a:m_version_A,
				media_id_b:m_media_id_B, page_b:page, clip_path_b:use_clip_path_B, box_b:use_box_B, version_b:m_version_B,
				options:m_option_values
			};
			m_last_callback_request = $.postJSON('json/media/structure-compare', postdata, function(j) {
				if( m_dlg_ddv===null ) return; // canceled (dialog was closed)
				if( m_site_comparing_actual_site < 0 && page > 0 ) {
					_load_data(1,ondone);
				}
				if( m_site_differences===null ) return;
				if( m_mode=='side-by-side' ) {
					var elem = m_dlg_ddv.find('.compare_contents').children('tr[data-page="'+page+'"]').children('td');
					elem.removeClass('loading');
				}
				if( j && j.hasOwnProperty('page_diffs') && j.page_diffs.hasOwnProperty(pd_key) ) {
					// var ndiffs = parseInt(j.page_diffs[pd_key].ndifferences);
					// var textDiffs;
					// if( ndiffs===0 ) textDiffs = mjt('mv-compare-mode-complete-contents-diff-0');
					// else if( ndiffs===1 ) textDiffs = mjt('mv-compare-mode-complete-contents-diff-1');
					// else textDiffs = mjt('mv-compare-mode-complete-contents-diff-n').replace('%1',ndiffs);
					// var textPage = mjt('mv-compare-mode-complete-contents-diff-page').replace('%1',page);
					// var textCombined = mjt('mv-compare-mode-complete-contents-diff-combined').replace('%1',textPage).replace('%2',textDiffs);
					// m_site_differences[pd_key] = { page:page, ndiffs:ndiffs, inselect:true, textPage:textPage, textDiffs:textDiffs, textCombined:textCombined, result:j };
					m_site_differences[pd_key] = _create_site_diff(j,page,pd_key);
					print_StructureCompare(m_site_differences[pd_key],null);
				} else {
					var err_txt = mjt('mv-compare-mode-contents-failed','!');
					if( j && j.error ) err_txt += ' ('+j.error+')';
					else err_txt += ' (1)';
					setStatusText(err_txt);
					return;
				}
				if( page+1 <= Math.min(page_count_A,page_count_B) ) {
					_load_data(page+1,ondone);
					return;
				} else if( ondone ) {
					ondone();
				}
			} );
		};
		_load_data(start_page,ondone);
	}

	function setupMetadataDiffView( page_count_A, page_count_B ) {

		if( m_contents_mode_enabled ) {
			var shared_page_count = Math.min(page_count_A,page_count_B),
				max_page_count = Math.max(page_count_A,page_count_B);

			if( shared_page_count>1 ) m_show_site_difference_select = true;

			// append container for complete-site-compare
			var oc_id = 'mv-compare-form-complete-contents-info',
				rows_html = [],
				odd = true,
				page = 1,
				textPage;
			for( page=1; page<=shared_page_count; ++page ) {
				textPage = mjt('mv-compare-mode-complete-contents-diff-page').replace('%1',page);
				rows_html.push('<tr class="md-page-cci '+(odd?'odd':'even')+'" data-page="'+(page)+'"><th>'+textPage+'</th><td colspan="2"></td></tr>');
				odd = !odd;
			}
			if( max_page_count > shared_page_count ) {
				var unshared_page_count = max_page_count - shared_page_count;
				textPage = unshared_page_count===1
					? mjt('mv-compare-mode-complete-contents-further-1').replace('%1',page)
					: mjt('mv-compare-mode-complete-contents-further-n').replace('%1',page).replace('%2',max_page_count);
				var textA = page_count_A > shared_page_count
					? ( unshared_page_count===1 ? mjt('mv-compare-mode-complete-contents-further-pages-1') : mjt('mv-compare-mode-complete-contents-further-pages-n') )
					: ( unshared_page_count===1 ? mjt('mv-compare-mode-complete-contents-further-pages-1-missing') : mjt('mv-compare-mode-complete-contents-further-pages-n-missing') );
				var textB = page_count_B > shared_page_count
					? ( unshared_page_count===1 ? mjt('mv-compare-mode-complete-contents-further-pages-1') : mjt('mv-compare-mode-complete-contents-further-pages-n') )
					: ( unshared_page_count===1 ? mjt('mv-compare-mode-complete-contents-further-pages-1-missing') : mjt('mv-compare-mode-complete-contents-further-pages-n-missing') );
				rows_html.push('<tr class="md-page-cci md-page-cci-further differ '+(odd?'odd':'even')+'"><th>'+textPage+'</th><td>'+textA+'</td><td>'+textB+'</td></tr>');
			}

			var complete_contents_info = $('<div id="'+oc_id+'" class="media-left-container mmd-meta-container">'
											+'<div class="title" mj_oc_container="#'+oc_id+' > .content" mj_oc_id="'+oc_id+'" mj_oc_default="open"><span class="open-close-handle"></span>'+mjt('mv-compare-mode-complete-contents')+'</div>'
											+'<div class="content"><table><tbody class="compare_contents">'+rows_html.join('')+'</tbody></table></div>'
											+'</div>').prependTo(m_dlg_ddv);
			update_common_hooks(complete_contents_info);
		}

		m_dlg_ddv.children('.media-left-container').each( function() {
			var cnt_A = $(this),
				cnt_id_A = cnt_A.prop('id'),									// e.g.: "mv-compare-form-ddv_common-video"
				cnt_id_B = cnt_id_A.substr(0,16)+'r'+cnt_id_A.substr(17),		// e.g.: "mv-compare-form-rdv_common-video"
				cnt_B = m_dlg_rdv.children('#'+cnt_id_B);
			var cnt_AB_type = cnt_A.hasClass('mmd-meta-container') ? 'meta' : ( cnt_A.hasClass('mmd-categories-container') ? 'categories' : ( cnt_A.hasClass('mmd-ext-container') ? 'ext' : 'unknown' ) );
			if( cnt_AB_type=='ext' ) {
				// just hide ext containers & also remove its dom element (delayed callbacks may try to reactivate it..)
				cnt_A.hide().remove();
			} else {
				if( cnt_A.css('display')=='none' && cnt_B.css('display')!='none' ) cnt_A.show();
				if( cnt_A.css('display')!='none' ) {
					var cnt_A_table = cnt_A.children('.content').children('table'),
						cnt_B_table = cnt_B.children('.content').children('table');
					if( cnt_AB_type=='meta' ) {
						// meta-data rows...
						cnt_A_table.find('tr.md-m').each( function() {
							var row_A = $(this);
							var meta_id = row_A.data('meta_id');
							var row_B = cnt_B_table.find('tr.md-m[data-meta_id='+meta_id+']');
							if( row_A.hasClass('md-hide') && !row_B.hasClass('md-hide') ) row_A.removeClass('md-hide').addClass('md-avl').show();
							// copy data column from B to here
							row_A.append(row_B.children('td').clone(true));
							// mark differences - cheap & dirty method, but works:
							var tds = row_A.children('td'),
								differ = tds.get(0).innerHTML != tds.get(1).innerHTML;
							if( differ ) row_A.addClass('differ');
							tds.first().addClass('compare-A').end()
								.last().addClass('compare-B');
						} );
					} else if( cnt_AB_type=='categories' ) {
						// category rows...
						cnt_A_table.find('tr.md-t').each( function() {
							var row_A = $(this);
							var tree_id = row_A.data('tree_id');
							var row_B = cnt_B_table.find('tr.md-t[data-tree_id='+tree_id+']');
							if( row_A.hasClass('md-hide') && !row_B.hasClass('md-hide') ) row_A.removeClass('md-hide').addClass('md-avl').show();
							// copy data column from B to here
							row_A.append(row_B.children('td').clone(true));
							// mark differences - cheap & dirty method, but works:
							var tds = row_A.children('td'),
								differ = tds.get(0).innerHTML != tds.get(1).innerHTML;
							if( differ ) row_A.addClass('differ');
							tds.first().addClass('compare-A').end()
								.last().addClass('compare-B');
						} );
					}
					// re-set odd and even classes on rows
					var odd = true;
					cnt_A_table.find('tr.md-m,tr.md-t').not('.md-hide').each( function() {
						toggleMultipleClasses0(this,{'odd':odd,'even':!odd});
						odd = !odd;
					} );
				}
			}
		}).end()
			.show()
			.scrollTop(0);

		if( m_contents_mode_enabled ) {
			if( m_site_comparing_actual_site==0 ) {
				parseCompleteDocument(1);
			} else {
				for( var pd_key in m_site_differences ) {
					if( !m_site_differences.hasOwnProperty(pd_key) ) continue;
					print_StructureCompare(m_site_differences[pd_key],null);
				}
			}
		}
	}

	function print_StructureCompare( obj, opt_goto_page ) {
		if( m_mode==='side-by-side' ) {
			if( obj!==null && obj.page!==0 ) {
				var row = m_dlg_ddv.find('.compare_contents').children('tr.md-page-cci[data-page="'+obj.page+'"]'),
					elem = row.children('td');
				if( obj.ndiffs>0 ) {
					if( obj.ndiffs>0 ) row.addClass('differ');
					elem.addClass('link')
						.on('click.mjMVCompare', function() {
							setupCompareView_for_mode('contents', $(this).parent('tr').data('page'));
						});
				}
				elem.text(obj.textDiffs);
			}
		} else if( m_show_site_difference_select ) {
			const $scs = $('.site-compare-select',m_dlg);
			if( $scs.length ) {
				if( obj !== null && obj.inselect ) {
					$scs.mjWidget( 'add', [[obj.page, obj.textCombined]], opt_goto_page );
				} else {
					var site_values = [];
					for( var pd_key in m_site_differences ) {
						if( !m_site_differences.hasOwnProperty(pd_key) ) continue;
						if( !m_site_differences[pd_key].inselect ) continue;
						site_values.push([ m_site_differences[pd_key].page, m_site_differences[pd_key].textCombined ]);
					}
					// console.log({w:'print_StructureCompare -> replace values...', site_values, m_site_differences_KEYS:Object.keys(m_site_differences).join(','), m_site_differences:JSON.stringify(m_site_differences) });
					$scs.mjWidget( 'replace', site_values, opt_goto_page );
				}
			}
		}
	}

	function setupCompareItemToolbar( side_elem, tb_html, media_id ) {
		var toolbar_elem = side_elem.children('.toolbar').html(tb_html).children('.preview-toolbar');
		var action_elems = toolbar_elem.find('.buttons .icon').hide();
		action_elems.filter('.mdb-delete-i')
			.show().on('click.mjMVCompare',function() {
				delete_media(
					[media_id],
					function _deleted_cb( deleted_mids ) {
						_destroy_dlg();
					},
					function _restored_cb( restored_media_ids ) {
						// _destroy_dlg();
					}
				);
			} );
		return toolbar_elem;
	}

	function setupCompareView_SideBySide() {
		m_dlg_menu.hide();
		_dlg_resize_handler(false);
		// setup metadata views
		var _mdd_views_populated_count = 0;
		var page_count_A = m_dtinfo_A.meta[501],
			page_count_B = m_dtinfo_B.meta[501];

		MVMediaMetadata.setupMetadataView( m_dlg_ddv, function() {
			MVMediaMetadata.setupMetadataViewData( m_dlg_ddv, m_media_id_A, m_dtinfo_A, false, false, function(container,rows,can_edit) { } );
			if( ++_mdd_views_populated_count===2 ) setupMetadataDiffView(page_count_A,page_count_B);
		}, 'compare_A_' );

		MVMediaMetadata.setupMetadataView( m_dlg_rdv, function() {
			MVMediaMetadata.setupMetadataViewData( m_dlg_rdv, m_media_id_B, m_dtinfo_B, false, false, function(container,rows,can_edit) { } );
			if( ++_mdd_views_populated_count===2 ) setupMetadataDiffView(page_count_A,page_count_B);
		}, 'compare_B_' );

		// setup preview canvases
		MTemplates.queryTemplateHTML( 'fragment_media_toolbar_wrap', function(id,tb_html) {

			var _previews_setup_count = 0;
			var cv_A = m_dlg_left.show().children('.canvas').off('.mjMVCompare');
			var tb_A = setupCompareItemToolbar(m_dlg_left,tb_html,m_media_id_A);
			cv_A.mjMVComparePreview(
				{
					dtinfo:m_dtinfo_A,
					width:cv_A.innerWidth(),
					height:cv_A.innerHeight(),
					toolbar:tb_A[0],
					view_link_available:true,
					view_link_auto_on_count:2,
					view_link_group_pfx:'aLft_',
					setup_done:function(e) {
						if( ++_previews_setup_count === 2 ) _previews_setup_count = 0;
					},
				}
			);

			var cv_B = m_dlg_right.show().children('.canvas').off('.mjMVCompare');
			var tb_B = setupCompareItemToolbar(m_dlg_right,tb_html,m_media_id_B);
			cv_B.mjMVComparePreview(
				{
					dtinfo:m_dtinfo_B,
					width:cv_B.innerWidth(),
					height:cv_B.innerHeight(),
					toolbar:tb_B[0],
					view_link_available:true,
					view_link_auto_on_count:2,
					view_link_group_pfx:'bRgt_',
					setup_done:function(e) {
						if( ++_previews_setup_count === 2 ) _previews_setup_count = 0;
					},
				}
			);

		});
	}

	function getPx2PxViewImgSrc( dtinfo, page, img_w, img_h, zoom_area ) {
		var mc = dtinfo.meta[-1] ? dtinfo.meta[-1][0] : 0,
			use_box = dtinfo.meta[238] ? dtinfo.meta[238][0] : '',
			cq = dtinfo.meta[233] && dtinfo.meta[233].length ? '&clip_path='+(dtinfo.meta[234]?parseInt(dtinfo.meta[234][0],0):-1) : '',
			bq = use_box ? '&box='+encodeURIComponent(use_box) : '',
			vq = dtinfo.is_latest_version ? '' : '&version='+encodeURIComponent(dtinfo.version),
			r = dtinfo.meta[229] ? parseInt(dtinfo.meta[229][0],10) : 0,
			t = dtinfo.meta[235] ? parseInt(dtinfo.meta[235][0],10) : 0;
		var url = mj.webroot+'media/file/preview/id/'+dtinfo.media_id+'_'+mc+'_'+page+'_'+img_w+'_'+img_h;
		if( zoom_area ) url += '_'+zoom_area[0]+'_'+zoom_area[1]+'_'+zoom_area[2]+'_'+zoom_area[3];
		url += '.png?modified='+encodeURIComponent(dtinfo.meta[-4]?dtinfo.meta[-4][0]:'')
					+ '&rotate='+r
					+ '&transparency='+t
					+ '&fill=2'
					+ cq + bq + vq;
		return mj.fixAssetURL(url);
	}

	function getPx2PxViewDimensions( view_w, view_h, img_dim ) {
		var view_aspect = view_w/view_h,
			img_w = img_dim[0],
			img_h = img_dim[1],
			img_aspect = img_dim.length>=5 ? img_dim[4] : img_w/img_h;	// = w/h
		// image dimensions unknown?
		if( img_w==0 && img_h==0 ) {
			// compute dimensions according to known image aspect ratio, to just fit into view
			if( view_w/img_aspect > view_h ) {
				// fit to view height
				img_h = view_h;
				img_w = Math.round( view_h*img_aspect );
			} else {
				// fit to view width
				img_w = view_w;
				img_h = Math.round( view_w/img_aspect );
			}
		}
		// fit to view...
		if( img_w>view_w || img_h>view_h ) {
			img_aspect = img_w / img_h;
			if( img_aspect > view_aspect ) {
				img_w = view_w;
				img_h = Math.round( view_w/img_aspect );
			} else {
				img_h = view_h;
				img_w = Math.round( view_h*img_aspect );
			}
		}
		return [img_w,img_h];
	}

	function setupPx2PxView( target_view, view_w, view_h, target_dim, page, callback, initially_hidden ) {
		var img_dim = getPx2PxViewDimensions(view_w,view_h,target_dim);
		var md_image = $('<div class="md-image-x"></div>')
			.appendTo(target_view);
		if( initially_hidden ) md_image.hide();
		// + center on target_view ...
		md_image.css( {
			left:Math.round(5+(view_w-img_dim[0])/2)+'px', top:Math.round(5+(view_h-img_dim[1])/2)+'px',
			width:img_dim[0]+'px', height:img_dim[1]+'px',
		} );
		callback(md_image,page,img_dim[0],img_dim[1]);
		return md_image;
	}

	function addSliderControlToPx2PxMenu( opts, value_changed, initial_trigger ) {
		var slider_opts = mj_deep_extend({},opts);
		slider_opts.orientation = 'horizontal';
		slider_opts.animate = 'fast';
		slider_opts.slide = function(e,ui) {
			var val = ui.value || $(this).slider('value');
			value_changed(val,false);
		};
		slider_opts.change = function(e,ui) {
			var val = ui.value || $(this).slider('value');
			value_changed(val,true);
		};
		var ctrls2 = m_dlg_menu.find('.ctrls2')
			.append( '<span class="slider-icon1 link" tabindex="0"></span>'
								+'<span class="slider"><div class="ui-slider-handle"></div></span>'
								+'<span class="slider-icon2 link" tabindex="0"></span>' );
		var slider = ctrls2.find('.slider').slider(slider_opts);
		var xstep = slider_opts.hasOwnProperty('xstep') ? slider_opts.xstep
			: ( slider_opts.hasOwnProperty('step') ? 2*slider_opts.step : 0.1 );
		ctrls2.find('.slider-icon1').click( function() {
			slider.slider('value',slider.slider('value')-xstep);
		} );
		ctrls2.find('.slider-icon2').click( function() {
			slider.slider('value',slider.slider('value')+xstep);
		} );
		if( initial_trigger ) value_changed(slider.slider('value'),true);
	}

	function _get_image_data( img, cv_w, cv_h ) {
		var canvas = document.createElement('canvas');
		canvas.width = cv_w;
		canvas.height = cv_h;
		var context = canvas.getContext('2d');
		context.drawImage(img,0,0);
		return context.getImageData(0,0,cv_w,cv_h);
	}

	function _drawDiffImage( dmm, imgD_A,imgD_B, context_T, cv_w,cv_h ) {

		var imgD_T = context_T.createImageData(cv_w,cv_h);
		// process pixel data
		var trg = imgD_T.data,
			len = trg.length,
			dst = imgD_A.data,
			src = imgD_B.data;
		var px, i, dfn_sq;
		// pre-compute distances
		if( m_distances_arr==null ) {

			m_distances_arr = typeof Float32Array=='undefined' ? new Array(len/4) : new Float32Array(len/4);
			if( m_distance_function=='deltaE_CIE94' || m_distance_function=='deltaE_CIE76' ) {
				dfn_sq = m_distance_function=='deltaE_CIE94' ? MDColorUtil.deltaE_CIE94_sq : MDColorUtil.deltaE_CIE76_sq;
				var sLAB, prv_sLAB, prv_sLAB_px=null,
					dLAB, prv_dLAB, prv_dLAB_px=null;
				for( px=0, i=0; px<len; px+=4, i++ ) {
					if( src[px]==dst[px] && src[px+1]==dst[px+1] && src[px+2]==dst[px+2] ) {
						// fast path: pixels match exactly... - deltaE=0
						m_distances_arr[i] = 0;
					} else {
						if( prv_sLAB_px!==null && src[px]==src[prv_sLAB_px] && src[px+1]==src[prv_sLAB_px+1] && src[px+2]==src[prv_sLAB_px+2] ) {
							// re-use previous LAB value
							sLAB = prv_sLAB;
						} else {
							prv_sLAB = sLAB = MDColorUtil.sRGB2Lab(src[px],src[px+1],src[px+2]);
							prv_sLAB_px = px;
						}
						if( prv_dLAB_px!==null && dst[px]==dst[prv_dLAB_px] && dst[px+1]==dst[prv_dLAB_px+1] && dst[px+2]==dst[prv_dLAB_px+2] ) {
							// re-use previous LAB value
							dLAB = prv_dLAB;
						} else {
							prv_dLAB = dLAB = MDColorUtil.sRGB2Lab(dst[px],dst[px+1],dst[px+2]);
							prv_dLAB_px = px;
						}
						m_distances_arr[i] = dfn_sq(sLAB,dLAB);
					}
				}
			} else if( m_distance_function=='RGB0' || m_distance_function=='RGB1' || m_distance_function=='RGB2' || m_distance_function=='RGB3' ) {
				dfn_sq = m_distance_function=='RGB0' ? MDColorUtil.dist_RGB0 : ( m_distance_function=='RGB1' ? MDColorUtil.dist_RGB1_sq : ( m_distance_function=='RGB2' ? MDColorUtil.dist_RGB2_sq : MDColorUtil.dist_RGB3_sq ) );
				for( px=0, i=0; px<len; px+=4, i++ ) {
					if( src[px]==dst[px] && src[px+1]==dst[px+1] && src[px+2]==dst[px+2] ) {
						// fast path: pixels match exactly... - deltaE=0
						m_distances_arr[i] = 0;
					} else {
						m_distances_arr[i] = dfn_sq( src[px],src[px+1],src[px+2], dst[px],dst[px+1],dst[px+2] );
					}
				}
			}
		}
		if( m_diff_swap_AB ) {
			dst = imgD_B.data,
			src = imgD_A.data;
		}
		var hlc1 = parseInt( m_highlight_color.indexOf('#') > -1 ? m_highlight_color.substring(1) : m_highlight_color, 16),
			hlc = [ hlc1>>16, (hlc1&0x00FF00)>>8, hlc1&0x0000FF ],
			hla = m_highlight_alpha,
			hlo = 1-hla,
			hlca = [ hla*hlc[0], hla*hlc[1], hla*hlc[2] ]; // = highlight color with pre-multiplied alpha
		// all distance are squared (except RGB0) -> compare with squared tolerance value
		var compare2dt = m_distance_function=='RGB0' ? m_distance_tolerance : m_distance_tolerance*m_distance_tolerance;
		if( dmm=='blend' ) {
			// difference BLENDING
			var sA,dA,dA2, sRA,sGA,sBA, dRA,dGA,dBA,dm;
			for( px=0; px<len; px+=4 ) {
				sA = src[px+3]/255;
				dA = dst[px+3]/255;
				dA2 = (sA+dA-sA*dA);
				sRA = src[px  ]/255*sA;
				sGA = src[px+1]/255*sA;
				sBA = src[px+2]/255*sA;
				dRA = dst[px  ]/255*dA;
				dGA = dst[px+1]/255*dA;
				dBA = dst[px+2]/255*dA;
				dm = 255/dA2;
				trg[px  ] = (sRA+dRA-2*Math.min(sRA*dA,dRA*sA))*dm;
				trg[px+1] = (sGA+dGA-2*Math.min(sGA*dA,dGA*sA))*dm;
				trg[px+2] = (sBA+dBA-2*Math.min(sBA*dA,dBA*sA))*dm;
				trg[px+3] = dA2*255;
			}
			context_T.putImageData(imgD_T,0,0);
		} else if( dmm=='mask' ) {
			// difference MASKING - using distance & a tolerance
			for( px=0, i=0; px<len; px+=4, i++ ) {
				if( m_distances_arr[i] > compare2dt ) {
					trg[px  ] = hlc[0];
					trg[px+1] = hlc[1];
					trg[px+2] = hlc[2];
					trg[px+3] = Math.max(dst[px+3],src[px+3]);
				} else {
					trg[px  ] = 0;
					trg[px+1] = 0;
					trg[px+2] = 0;
					trg[px+3] = dst[px+3];
				}
			}
			context_T.putImageData(imgD_T,0,0);
		} else if( dmm=='abs-mask' ) {
			// full value difference MASKING, including color AND alpha differences...
			for( px=0; px<len; px+=4 ) {
				if( dst[px+0]!=src[px+0] || dst[px+1]!=src[px+1] || dst[px+2]!=src[px+2] || dst[px+3]!=src[px+3] ) {
					trg[px  ] = hlc[0];
					trg[px+1] = hlc[1];
					trg[px+2] = hlc[2];
					trg[px+3] = 255;
				} else {
					trg[px  ] = 0;
					trg[px+1] = 0;
					trg[px+2] = 0;
					trg[px+3] = 255;
				}
			}
			context_T.putImageData(imgD_T,0,0);
		} else if( dmm=='highlight1' ) {
			// difference MASKING - using distance & a tolerance
			for( px=0, i=0; px<len; px+=4, i++ ) {
				if( m_distances_arr[i] > compare2dt ) {
					trg[px  ] = hlo*dst[px  ] + hlca[0];
					trg[px+1] = hlo*dst[px+1] + hlca[1];
					trg[px+2] = hlo*dst[px+2] + hlca[2];
					trg[px+3] = Math.max(dst[px+3],src[px+3]);
				} else {
					trg[px  ] = dst[px  ];
					trg[px+1] = dst[px+1];
					trg[px+2] = dst[px+2];
					trg[px+3] = dst[px+3];
				}
			}
			context_T.putImageData(imgD_T,0,0);
		} else if( dmm=='highlight3' ) {
			// difference MASKING - using distance & a tolerance
			// blit A to target
			context_T.putImageData(m_diff_swap_AB?imgD_B:imgD_A,0,0);
			// process & draw differences onto target canvas
			context_T.fillStyle = m_highlight_color;
			context_T.globalAlpha = 0.125*m_highlight_alpha;
			for( px=0, i=0; px<len; px+=4, i++ ) {
				if( m_distances_arr[i] > compare2dt ) {
					// add highlight rect
					var y=Math.floor(i/cv_w), x=i%cv_w;
					context_T.fillRect( x-1.5, y-1.5, 4,4 );
				}
			}
			context_T.globalAlpha = 1.0;

		} else if( dmm=='copyA' ) {
			context_T.putImageData(m_diff_swap_AB?imgD_B:imgD_A,0,0);

		} else if( dmm=='copyB' ) {
			context_T.putImageData(m_diff_swap_AB?imgD_A:imgD_B,0,0);

		}

	}

	function _setupCompareView_Px2PxOnionSkin_mjsresize( page, view_w, view_h, target_dim, zoomed_dim ) {

		m_dlg_mid.mjImageZoomWidget('resetViews',m_zoom_area===null?true:false,target_dim[0],target_dim[1]);

		//var md_image_A =
		setupPx2PxView( m_dlg_mid, view_w, view_h, zoomed_dim, page, function( md_image, page, img_w ,img_h ) {
			md_image.html('<img src="'+htmlspecialchars(getPx2PxViewImgSrc(m_dtinfo_A,page,img_w,img_h,m_zoom_area),true,true)+'" />');
			m_dlg_mid.mjImageZoomWidget('addView',md_image.children('img').first(),target_dim[0],target_dim[1],img_w,img_h);
		} );
		var md_image_B = setupPx2PxView( m_dlg_mid, view_w, view_h, zoomed_dim, page, function( md_image, page, img_w, img_h ) {
			md_image.html('<img src="'+htmlspecialchars(getPx2PxViewImgSrc(m_dtinfo_B,page,img_w,img_h,m_zoom_area),true,true)+'" />');
			//m_dlg_mid.mjImageZoomWidget('addView',md_image.children('img').first(),target_dim[0],target_dim[1],img_w,img_h);
		} );

		// +opacity slider
		addSliderControlToPx2PxMenu(
			{ value:m_opacity, min:0,max:1, step:0.05, xstep:0.05 },
			function(v,s) {
				m_opacity = v;
				md_image_B.css('opacity',v);
			},
			true
		);
		m_dlg_mid.removeClass('loading');
	}

	function _setupCompareView_Px2PxDiff_mjsresize( page, view_w, view_h, target_dim, zoomed_dim ) {

		m_distances_arr = null;

		var md_image_T = [],
			context_T = [],
			full_img_dim = getPx2PxViewDimensions(view_w,view_h,zoomed_dim),
			cv_w = full_img_dim[0],
			cv_h = full_img_dim[1],
			tv_layout = '2x2',
			tv_w = cv_w,
			tv_h = cv_h,
			ddx = 3,
			ddy = 3,
			tv_full_w = (ddx+cv_w+ddx),
			tv_full_h = (ddy+cv_h+ddy);

		if( view_w > 4*tv_full_w-4 ) {
			// => 4x1 layout at full height
			tv_layout = '4x1';
		} else if( view_h > 4*tv_full_h-4 ) {
			// => 1x4 layout at full height
			tv_layout = '1x4';
		} else {
			var tmp4x1 = getPx2PxViewDimensions(Math.floor(view_w/4-2*ddx),view_h,zoomed_dim),
				tmp1x4 = getPx2PxViewDimensions(view_w,Math.floor(view_h/4-2*ddy),zoomed_dim),
				tmp2x2 = getPx2PxViewDimensions(Math.floor(view_w/2-1),Math.floor(view_h/2-1),zoomed_dim);
			if( tmp4x1[1] > tmp2x2[1] ) {
				// => 4x1 layout with adapted height
				tv_layout = '4x1';
				tv_w = tmp4x1[0];
				tv_h = tmp4x1[1];
			} else if( tmp1x4[0] > tmp2x2[0] ) {
				// => 1x4 layout with adapted width
				tv_layout = '1x4';
				tv_w = tmp1x4[0];
				tv_h = tmp1x4[1];
			} else {
				// => 2x2 layout
				tv_w = tmp2x2[0];
				tv_h = tmp2x2[1];
			}
		}

		var _setup_dmm_view = function( dmm ) {
			var i;
			md_image_T = [];

			m_dlg_mid
				.mjImageZoomWidget('resetViews',m_zoom_area===null?true:false,target_dim[0],target_dim[1])
				.children('div.md-image-x').remove().end();

			if( dmm=='A-B-hl-mask' ) {
				for( i=0; i<4; ++i ) {
					md_image_T[i] = setupPx2PxView( m_dlg_mid, view_w,view_h, zoomed_dim, page, function( md_image, page, img_w,img_h ) {
						md_image
							.html('<canvas width="'+img_w+'" height="'+img_h+'" />')
							.children('canvas').css( { width:tv_w+'px', height:tv_h+'px' } ).end()
							.css( { width:tv_w+'px', height:tv_h+'px' } );
					}, true );
				}
				var ctr_x = Math.round( 4 + view_w/2 + 0.5 ),
					ctr_y = Math.round( 4 + view_h/2 + 0.5 );
				if( tv_layout=='4x1' ) {
					var top_y = Math.round(ctr_y-tv_h/2);
					md_image_T[0].css( {left:(ctr_x-ddx-tv_w-ddx-tv_w-ddx)+'px',	top:(top_y)+'px' } );
					md_image_T[1].css( {left:(ctr_x-ddx-tv_w)+'px',					top:(top_y)+'px' } );
					md_image_T[2].css( {left:(ctr_x+ddx)+'px',						top:(top_y)+'px' } );
					md_image_T[3].css( {left:(ctr_x+ddx+tv_w+ddx+ddx)+'px',			top:(top_y)+'px' } );
				} else if( tv_layout=='1x4' ) {
					var left_x = Math.round(ctr_x-tv_w/2);
					md_image_T[0].css( {left:(left_x)+'px',				top:(ctr_y-ddy-tv_h-ddy-tv_h-ddy)+'px' } );
					md_image_T[1].css( {left:(left_x)+'px',				top:(ctr_y-ddy-tv_h)+'px' } );
					md_image_T[2].css( {left:(left_x)+'px',				top:(ctr_y+ddy)+'px' } );
					md_image_T[3].css( {left:(left_x)+'px',				top:(ctr_y+ddy+tv_h+ddy+ddy)+'px' } );
				} else {
					md_image_T[0].css( {left:(ctr_x-ddx-tv_w)+'px',		top:(ctr_y-ddy-tv_h)+'px' } );
					md_image_T[1].css( {left:(ctr_x+ddx)+'px',			top:(ctr_y-ddy-tv_h)+'px' } );
					md_image_T[2].css( {left:(ctr_x-ddx-tv_w)+'px',		top:(ctr_y+ddy)+'px' } );
					md_image_T[3].css( {left:(ctr_x+ddx)+'px',			top:(ctr_y+ddy)+'px' } );
				}
				for( i=0; i<4; ++i ) context_T[i] = md_image_T[i].children('canvas')[0].getContext('2d');

				m_dlg_mid.mjImageZoomWidget('addView',md_image_T[0].children('canvas'),m_dim_A[0],m_dim_A[1],tv_w,tv_h);
				m_dlg_mid.mjImageZoomWidget('addView',md_image_T[1].children('canvas'),m_dim_B[0],m_dim_B[1],tv_w,tv_h);
				m_dlg_mid.mjImageZoomWidget('addView',md_image_T[2].children('canvas'),target_dim[0],target_dim[1],tv_w,tv_h);
				m_dlg_mid.mjImageZoomWidget('addView',md_image_T[3].children('canvas'),target_dim[0],target_dim[1],tv_w,tv_h);

			} else {
				md_image_T[0] = setupPx2PxView( m_dlg_mid, view_w,view_h, zoomed_dim, page, function( md_image, page, img_w,img_h ) {
					md_image
						.html('<canvas width="'+img_w+'" height="'+img_h+'" />')
						.children('canvas').css( { width:cv_w+'px', height:cv_h+'px' } ).end()
						.css( { width:cv_w+'px', height:cv_h+'px' } );
				}, true );
				context_T[0] = md_image_T[0].children('canvas')[0].getContext('2d');

				m_dlg_mid.mjImageZoomWidget('addView',md_image_T[0].children('canvas'),target_dim[0],target_dim[1],cv_w,cv_h);
			}
		};

		var img_A = new Image(),
			imgD_A = null,
			img_B = new Image(),
			imgD_B = null;

		var _draw_diff_images = function( dmm ) {
			if( dmm!=m_diff_mask_mode || context_T.length<1 ) {
				_setup_dmm_view(dmm);
				m_diff_mask_mode = dmm;
			}
			if( dmm=='A-B-hl-mask' ) {
				// 4 views: TopLeft: A				TopRight: B
				//			BtmLeft: highlight1		BtmRight: mask
				_drawDiffImage(      'copyA', imgD_A,imgD_B, context_T[0], cv_w,cv_h );
				_drawDiffImage(      'copyB', imgD_A,imgD_B, context_T[1], cv_w,cv_h );
				_drawDiffImage( 'highlight1', imgD_A,imgD_B, context_T[2], cv_w,cv_h );
				_drawDiffImage(       'mask', imgD_A,imgD_B, context_T[3], cv_w,cv_h );
			} else {
				_drawDiffImage( dmm, imgD_A,imgD_B, context_T[0], cv_w,cv_h );
			}
			setTimeout( function() {
				m_dlg_mid
					.removeClass('loading')
					.children('.md-image-x').show();
			}, 100 );
		};

		// load images
		var _onload1_done = false;
		var _onload1 = function() {
			if( !_onload1_done && img_A.complete && img_B.complete ) {
				_onload1_done = true;
				imgD_A = _get_image_data(img_A,cv_w,cv_h);
				imgD_B = _get_image_data(img_B,cv_w,cv_h);
				_draw_diff_images(m_diff_mask_mode);
				//img_A = null;
				//img_B = null;
			}
		};
		img_A.onload = _onload1;
		img_B.onload = _onload1;
		img_A.src = getPx2PxViewImgSrc(m_dtinfo_A,page,cv_w,cv_h,m_zoom_area);
		img_B.src = getPx2PxViewImgSrc(m_dtinfo_B,page,cv_w,cv_h,m_zoom_area);
		_onload1();

		var _on_diff_mask_mode_changed = function(dmm) {};

		// diff modes
		var diff_mask_modes = [
			['A-B-hl-mask',mjt('mv-compare-diff-mask-mode-A-B-hl-mask','!')],
			['highlight1',mjt('mv-compare-diff-mask-mode-highlight1','!')],
			['highlight3',mjt('mv-compare-diff-mask-mode-highlight3','!')],
			['mask',mjt('mv-compare-diff-mask-mode-mask','!')],
			['abs-mask',mjt('mv-compare-diff-mask-mode-abs-mask','!')],
			['blend',mjt('mv-compare-diff-mask-mode-blend','!')],
		];
		var diff_mask_mode_wdg = $('<span class="diff-mask-mode"></span>').appendTo( m_dlg_menu.find('.ctrls2') );
		diff_mask_mode_wdg.mjWidget( { type:'list', name:'diff_mask_mode', values:diff_mask_modes, 'default':m_diff_mask_mode, addClass:'small', change:function() {
			var m = $(this).mjWidget('get');
			if( m!=m_diff_mask_mode ) {
				m_dlg_mid.addClass('loading').children('div.md-image-x').remove();
				_on_diff_mask_mode_changed(m);
				if( _onload1_done ) _draw_diff_images(m);
				else m_diff_mask_mode = m;
			}
		} } );

		// highlight color
		var highlight_color_wdg = $('<span class="highlight-color" tabindex="0"></span>').appendTo( m_dlg_menu.find('.ctrls2') );
		highlight_color_wdg
			.css('backgroundColor',m_highlight_color)
			.on( 'click.mjMVCompare', function() {
				var self = $(this);
				self.ColorPicker( {
					color: m_highlight_color,
					onShow: function( colpkr ) {
						$(colpkr).css('zIndex',1005).fadeIn(200);
						return false;
					},
					onHide: function( colpkr ) {
						$(colpkr).fadeOut(200);
						self.css('backgroundColor',m_highlight_color);
						return false;
					},
					onChange: function( hsb, hex, rgb ) {
						self.css('backgroundColor','#'+hex);
					},
					onSubmit: function( hsb, hex, rgb, el ) {
						m_highlight_color = '#'+hex;
						self.css('backgroundColor',m_highlight_color);
						self.ColorPickerHide();
						if( _onload1_done ) _draw_diff_images(m_diff_mask_mode);
					},
				} )
					.ColorPickerShow();
			} );

		// diff swap_AB
		var diff_swap_AB_wdg = $('<span class="swap-sides checkbox-group"></span>').appendTo( m_dlg_menu.find('.ctrls2') );
		diff_swap_AB_wdg.mjWidget( { type:'bool2', name:'diff_swap_AB', 'default':m_diff_swap_AB, addClass:'small', change:function() {
			var m = $(this).mjWidget('get');
			if( m!=m_diff_swap_AB ) {
				m_diff_swap_AB = m;
				if( _onload1_done ) _draw_diff_images(m_diff_mask_mode);
			}
		} } );
		diff_swap_AB_wdg.append('<label for="'+diff_swap_AB_wdg.mjWidget('id')+'"> '+mjt('mv-compare-diff-swap-AB')+'</label>');

		// distance function
		var distance_functions = [
			[ 'RGB0',			'RGB 0' ],// (manhattan d.)' ],
			[ 'RGB1',			'RGB 1' ],// (euclidian d.)' ],
			[ 'RGB2',			'RGB 2' ],// (euclidian w.d.)' ],
			[ 'RGB3',			'RGB 3' ],// (euclidian w.d.)' ],
			[ 'deltaE_CIE76',	'∆E CIE76' ],
			[ 'deltaE_CIE94',	'∆E CIE94' ],
		];
		var distance_function_wdg = $('<span class="distance-function"></span>').appendTo( m_dlg_menu.find('.ctrls2') );
		distance_function_wdg.mjWidget( { type:'list', name:'distance_function', values:distance_functions, 'default':m_distance_function, addClass:'small', change:function() {
			var f = $(this).mjWidget('get');
			if( f!=m_distance_function ) {
				m_distance_function = f;
				m_distances_arr = null; // will be recomputed on next draw
				if( _onload1_done ) _draw_diff_images(m_diff_mask_mode);
			}
		} } );

		// tolerance slider
		addSliderControlToPx2PxMenu(
			{ value:m_distance_tolerance, min:0,max:32, step:0.5, xstep:0.5 },
			function(v,s) {
				if( s && v!=m_distance_tolerance ) {
					m_distance_tolerance = v;
					if( _onload1_done ) _draw_diff_images(m_diff_mask_mode);
				}
			},
			false
		);

		_on_diff_mask_mode_changed = function( dmm ) {
			highlight_color_wdg.css('visibility',dmm=='blend'?'hidden':'visible');
			diff_swap_AB_wdg.css('visibility',dmm=='mask'||dmm=='abs-mask'||dmm=='blend'?'hidden':'visible');
			distance_function_wdg.css('visibility',dmm=='blend'||dmm=='abs-mask'?'hidden':'visible');
			m_dlg_menu.find('.ctrls2').find('.slider-icon1,.slider,.slider-icon2').css('visibility',dmm=='blend'||dmm=='abs-mask'?'hidden':'visible');
		};
		_on_diff_mask_mode_changed(m_diff_mask_mode);
	}

	function setupCompareView_Px2Px( mjsresize_cb, initialJumpToPage ) {
		if( typeof initialJumpToPage === 'undefined' ) initialJumpToPage = 1;
		var page = initialJumpToPage;
		m_dlg_menu.show();
		_dlg_resize_handler(false);
		var mjsresize_cb1 = function( page ) {
			var view_w = Math.max(10,m_dlg_mid.innerWidth()-10),
				view_h = Math.max(10,m_dlg_mid.innerHeight()-10),
				target_dim = m_dim_A[0]<m_dim_B[0] || m_dim_A[1]<m_dim_B[1] ? m_dim_A : m_dim_B,
				zoomed_dim = target_dim.slice(0);
			if( m_zoom_area!=null ) {
				zoomed_dim[0] = m_zoom_area[2];
				zoomed_dim[1] = m_zoom_area[3];
				zoomed_dim[4] = m_zoom_area[2] / m_zoom_area[3];
			}
			mjsresize_cb(page,view_w,view_h,target_dim,zoomed_dim);
		};
		var _on_resize = function( page ) {
			m_dlg_mid.addClass('loading').children('div.md-image-x').remove();
			m_dlg_menu.find('.ctrls2').empty();
			// request actual dimensions of page of of file ...
			var got_xdim_of_A = false,
				got_xdim_of_B = false;
			$.postJSON('json/media/meta-dimensions', 'media_id='+m_media_id_A+(m_dtinfo_A.is_latest_version?'':'&version='+m_dtinfo_A.version)+'&page='+page+'&box='+m_dim_A[5], function(j) {
				if( j && j.width>0 && j.height>0 ) {
					m_dim_A[0] = parseInt(j.width,10);
					m_dim_A[1] = parseInt(j.height,10);
					if( m_dim_A[2]==90 || m_dim_A[2]==270 ) {
						var tmp_x = m_dim_A[0];
						m_dim_A[0] = m_dim_A[1];
						m_dim_A[1] = tmp_x;
					}
					got_xdim_of_A = true;
					if( got_xdim_of_B ) mjsresize_cb1(page);
				}
			}, true );
			$.postJSON('json/media/meta-dimensions', 'media_id='+m_media_id_B+(m_dtinfo_B.is_latest_version?'':'&version='+m_dtinfo_B.version)+'&page='+page+'&box='+m_dim_B[5], function(j) {
				if( j && j.width>0 && j.height>0 ) {
					m_dim_B[0] = parseInt(j.width,10);
					m_dim_B[1] = parseInt(j.height,10);
					if( m_dim_B[2]==90 || m_dim_B[2]==270 ) {
						var tmp_x = m_dim_B[0];
						m_dim_B[0] = m_dim_B[1];
						m_dim_B[1] = tmp_x;
					}
					got_xdim_of_B = true;
					if( got_xdim_of_A ) mjsresize_cb1(page);
				}
			}, true );
			if( got_xdim_of_A && got_xdim_of_B ) mjsresize_cb1(page);
		};
		m_dlg_mid.off().on( 'mjsresize.mjMVCompare', function(e,w,h) {
			_on_resize(page);
		} );
		// + ctrls...
		m_zoom_area = null;

		m_dlg_mid
			.addClass('loading')
			.children('div.md-image-x').remove().end()
			.mjImageZoomWidget('destroy')
			.mjMediaPageNavWidget('destroy')
			.mjImageZoomWidget( {
				zoom_changed: function( evt, data ) {
					// data.area
					m_zoom_area = data.area;
					_on_resize(page);
				},
			} )
			.mjMediaPageNavWidget( {
				page_changed: function( evt, data ) {
					// data.page, data.npages, data.npages_actually_unknown
					m_zoom_area = null; // force reset of zoom stack
					page = data.page;
					_on_resize(page);
				},
			} )
			.mjMediaPageNavWidget('setupFrom2FilesMetadata',page,m_dtinfo_A.meta,m_dtinfo_B.meta)
			.show()
			.triggerHandler('mjsresize',[m_dlg_mid.width(),m_dlg_mid.height()]);
	}


	function setupCompareView_Contents( initialJumpToPage ) {
		if( typeof initialJumpToPage === 'undefined' ) initialJumpToPage = 1;

		var opt_name;
		var _loading_timer = {
			'both': null,
			'A': null,
			'B': null,
		};
		var _before_page_change_query_vals = {
			page: initialJumpToPage,
			filter_value: '',
		};
		var _additional_on_after_page_change_cb = null;


		function _on_after_page_change( AorB, triggerOnAorB, trigger_option_name, trigger_option_value ) {
			if( _loading_timer[triggerOnAorB] ) {
				return; // use active timeout ..
			}
			m_dlg_scedv.off('.mjMVCompare').empty().addClass('loading');
			m_dlg_overlays.empty();
			// start new timeout ..
			_loading_timer[triggerOnAorB] = setTimeout( function _tmo_on_load_structure_compare_data_done_after_page_change() {
				_loading_timer[triggerOnAorB] = null;
				_load_structure_compare_data( function _on_load_structure_compare_data_done_after_page_change() {
					// console.log({w:'_load_structure_compare_data AFTER 1', page_value: $('.site-compare-select',m_dlg).data('mj-widget') ? $('.site-compare-select',m_dlg).mjWidget('get') : null });
					if( triggerOnAorB=='both' ) {
						if( _additional_on_after_page_change_cb ) {
							var cb = _additional_on_after_page_change_cb;
							// _additional_on_after_page_change_cb = null;
							cb();
						}
					}
					// console.log({w:'_load_structure_compare_data AFTER 2', page_value: $('.site-compare-select',m_dlg).data('mj-widget') ? $('.site-compare-select',m_dlg).mjWidget('get') : null });
				});
			}, 120 );
		}

		var _previews_setup_count = 0;
		var options_wdg_group = $('<span class="checkbox-group"></span>').appendTo( m_dlg_menu.find('.ctrls2') );
		if( _object_empty(m_option_values) ) {
			for( opt_name in m_options ) {
				if( !m_options.hasOwnProperty(opt_name) ) continue;
				m_option_values[opt_name] = m_options[opt_name].def;
			}
		}
		for( opt_name in m_option_values ) {
			if( m_option_values.hasOwnProperty(opt_name) ) {
				const initially_checked = m_option_values[opt_name];
				if( m_options[opt_name].enables ) {
					for( const enables_opt_name of m_options[opt_name].enables ) {
						if( !m_options.hasOwnProperty(enables_opt_name) ) continue;
						m_options[enables_opt_name].disabled = !initially_checked;
					}
				}
				var $opt_wdg = $('<span />').mjWidget( { type:'bool2', name:opt_name, 'default':initially_checked, change:function() {
					const $wdg = $(this);
					const checked = $wdg.mjWidget('get');
					const opt_name = $wdg.mjWidget('name');
					$wdg.toggleClass('checked',checked);
					if( m_option_values.hasOwnProperty(opt_name) && checked!=m_option_values[opt_name] ) {
						m_option_values[opt_name] = checked;
					}
					if( m_options[opt_name].enables ) {
						for( const enables_opt_name of m_options[opt_name].enables ) {
							if( !m_options.hasOwnProperty(enables_opt_name) ) continue;
							const other_opt = m_options[enables_opt_name] ?? null;
							if( other_opt && other_opt.$span ) {
								other_opt.$span.toggle(checked);
							}
						}
					}
					// console.log({w:'setupCompareView_Contents -> OPTION changed', opt_name, checked, m_site_comparing_actual_site, m_site_differences_KEYS:Object.keys(m_site_differences).join(','), m_site_differences:JSON.stringify(m_site_differences)});
					// _on_after_page_change('both','both',opt_name,checked);
					// parseCompleteDocument(1);

					parseCompleteDocument( 1, function() {
						_on_after_page_change('both','both',opt_name,checked);
					} );

				} } ).appendTo(options_wdg_group);
				$opt_wdg.toggleClass('checked',initially_checked);
				$opt_wdg.append('<label for="'+$opt_wdg.mjWidget('id')+'"> '+m_options[opt_name].label+'</label>');
				m_options[opt_name].$span = $opt_wdg;
				if( m_options[opt_name].disabled ) {
					$opt_wdg.hide();
				}
			}
		}

		//console.log(option_values);

		m_dlg_menu.show();
		_dlg_resize_handler(false);
		m_dlg_sciv.show();
		m_dlg_scedv.show();
		m_dlg_overlays.show();

		var cv_A;
		var cv_B;

		var page_A = initialJumpToPage,
			use_clip_path_A = m_dtinfo_A.meta[234] ? parseInt(m_dtinfo_A.meta[234][0],10) : -1,
			use_box_A = m_dtinfo_A.meta[238] ? m_dtinfo_A.meta[238][0] : '';

		var page_B = initialJumpToPage,
			use_clip_path_B = m_dtinfo_B.meta[234] ? parseInt(m_dtinfo_B.meta[234][0],10) : -1,
			use_box_B = m_dtinfo_B.meta[238] ? m_dtinfo_B.meta[238][0] : '';


		//TODO: refactor...
		var connection_lines = [];
		var selected_elem_diff_idx = -1;
		var selected_elem_diff_idx2 = -1;

		function _destroy_connection_lines() {
			for( var edi=0; edi<connection_lines.length; ++edi ) {
				if( connection_lines[edi] ) {
					if( connection_lines[edi][0] ) connection_lines[edi][0].destroy();
					if( connection_lines[edi][1] ) connection_lines[edi][1].destroy();
				}
			}
			connection_lines = [];
		}
		function _update_connection_lines( cur_idx, cur_idx2 ) {
			for( var edi=0; edi<connection_lines.length; ++edi ) {
				if( connection_lines[edi][0] ) connection_lines[edi][0].toggle(edi==cur_idx||edi==cur_idx2);
				if( connection_lines[edi][1] ) connection_lines[edi][1].toggle(edi==cur_idx||edi==cur_idx2);
			}
		}

		function _wrap_ui_logic( v, d, l ) {
			if( d===0 )					return v;		// no delta = no change
			else if( v===0 && d<0 ) 	return l-1;		// go to last pos
			else if( v===l-1 && d>0 )	return 0;		// to first pos
			return clip(v+d,0,l-1);						// keep clipped in range
		}

		function _get_elem_diff_by_idx( idx ) {
			if( idx===null ) return null;
			var $entry = $('#'+m_dlg_id+'-ed-'+idx);
			return $entry;
		}

		function _get_elem_diff_overlays_by_idx( idx ) {
			if( idx===null ) return null;
			var overlays = $('#'+m_dlg_id+'-ed-a-'+idx+',#'+m_dlg_id+'-ed-b-'+idx);
			return overlays;
		}

		function _select_elem_diff_by_idx( idx, delta, opt_idx2 ) {
			if( typeof opt_idx2 === 'undefined' ) opt_idx2 = -1;

			var cv_AandB = cv_A.add(cv_B);
			cv_AandB.find('.md-overlay-box').removeClass('highlighted');
			m_dlg_scedv.children('.diff-elem-item').removeClass('highlighted');
			if( delta ) {
				if( idx===0 ) {
					idx = m_dlg_scedv.children('.diff-elem-item:visible').first().data('edi');
				} else {
					// delta element selection - based on visible elements ...
					var visible_edis = []; // idx => 'edi'
					var sel_vei = 0;
					m_dlg_scedv.children('.diff-elem-item:visible').each( function(i,e) {
						var edi = $.data(e,'edi');
						if( edi===selected_elem_diff_idx ) sel_vei = i;
						visible_edis[i] = edi;
					});
					sel_vei = _wrap_ui_logic(sel_vei,idx,visible_edis.length);
					idx = visible_edis[sel_vei];
				}
			}

			selected_elem_diff_idx = idx<0 ? -1 : idx;
			selected_elem_diff_idx2 = opt_idx2;
			_update_connection_lines(selected_elem_diff_idx,selected_elem_diff_idx2);

			m_dlg_overlays.find('.md-overlay-box').remove();

			if( selected_elem_diff_idx<0 && selected_elem_diff_idx2<0 ) {
				// hide all
			} else {
				// show selected entry and associated overlays
				var selected_entry = _get_elem_diff_by_idx(idx);
				selected_entry
					.add(_get_elem_diff_overlays_by_idx(idx))
					.addClass('highlighted');

				var padT = parseInt( m_dlg_scedv.css('padding-top') || '12', 10 );
				scrollElementIntoView( selected_entry, m_dlg_scedv, -padT, padT );

				if( opt_idx2 >= 0 ) {
					var selected_entry2 = _get_elem_diff_by_idx(opt_idx2);
					selected_entry2
						.add(_get_elem_diff_overlays_by_idx(opt_idx2))
						.addClass('highlighted');
					scrollElementIntoView( selected_entry2, m_dlg_scedv, -padT, padT );
				}
			}
		}

		function _cv_AandBbeforeX(e,page) {
			m_dlg_sciv.empty();
			m_dlg_scedv.empty();
			cv_A.triggerHandler('mjsoverlaysremove');
			cv_B.triggerHandler('mjsoverlaysremove');
		}

		function _previews_setup_done() {
			cv_A
				.add(cv_B)
				.off('.mjMVCompare')
				.on('mjsbeforepagechanged.mjMVCompare',_cv_AandBbeforeX)
				.on('mjsbeforeclippathchanged.mjMVCompare',_cv_AandBbeforeX)
				.on('mjsbeforeboxchanged.mjMVCompare',_cv_AandBbeforeX)
				.on('mjsafterzoomchanged.mjMVCompare',function(e) {
					requestAnimationFrame( function() {
						_update_connection_lines(selected_elem_diff_idx,selected_elem_diff_idx2);
					} );
				});

			function _setup_a_then_b( a,b, fun ) {
				fun(a,b,'A');
				fun(b,a,'B');
			}
			_setup_a_then_b( cv_A,cv_B, function( cv_X, cv_Y, x ) {
				cv_X.on('mjsafterpagechanged.mjMVCompare mjspageset.mjMVCompare',function(e,page) {
					if( x==='A' && page_A!=page ) {
						page_A = page;
						_on_after_page_change('A','both');
					} else if( x==='B' && page_B!=page ) {
						page_B = page;
						_on_after_page_change('B','both');
					}
				});
				cv_X.on('mjsafterclippathchanged.mjMVCompare mjsclippathset.mjMVCompare',function(e,use_clip_path) {
					if( x==='A' && use_clip_path_A!=use_clip_path ) {
						use_clip_path_A = use_clip_path;
						_on_after_page_change('A','both');
					} else if( x==='B' && use_clip_path_B!=use_clip_path ) {
						use_clip_path_B = use_clip_path;
						_on_after_page_change('B','both');
					}
				});
				cv_X.on('mjsafterboxchanged.mjMVCompare mjsboxset.mjMVCompare',function(e,use_box) {
					if( x==='A' && use_box_A!=use_box ) {
						use_box_A = use_box;
						_on_after_page_change('A','both');
					} else if( x==='B' && use_box_B!=use_box ) {
						use_box_B = use_box;
						_on_after_page_change('B','both');
					}
				});
				cv_X.on('mjsviewlinkupdate.mjMVCompare',function(e,sync_state) {
					_on_after_page_change('both','both');
				});
			});
		}

		var _defered_lscd_timer = null;

		function _load_structure_compare_data( ondone ) {
			m_dlg_sciv.empty();
			m_dlg_scedv
				.off('.mjMVCompare')
				.empty()
				.addClass('loading');

			var postdata = {
				media_id_a:m_media_id_A, page_a:page_A, clip_path_a:use_clip_path_A, box_a:use_box_A, version_a:m_version_A,
				media_id_b:m_media_id_B, page_b:page_B, clip_path_b:use_clip_path_B, box_b:use_box_B, version_b:m_version_B,
				options:m_option_values
			};
			var pd_key = page_A+':'+page_B;

			const $ciff0 = m_dlg_sciv.find('.compare-info-filter .filter');
			if( $ciff0.length && $ciff0.data('mj-widget') ) {
				// console.log({w:'DESTROY .compare-info-filter .filter'});
				$ciff0.mjWidget('destroy');
			}

			_additional_on_after_page_change_cb = function() {
				setTimeout( function() {
					const $scs = $('.site-compare-select',m_dlg);
					// const has_$scs = !!($scs.length && $scs.data('mj-widget'));
					// console.log({w:'_additional_on_after_page_change_cb',has_$scs,$scs_val:has_$scs?$scs.mjWidget('get'):null,_before_page_change_query_vals,page_LOWER:Math.min(page_A,page_B),page_A,page_B});

					if( $scs.length && $scs.data('mj-widget') ) {
						// const selected_page = Math.min(page_A,page_B);
						const selected_page = _before_page_change_query_vals.page;
						// console.log({w:'_additional_on_after_page_change_cb',selected_page,prev_page:_before_page_change_query_vals.prev_page});
						$scs.mjWidget('set',selected_page);
					}

					const $ciff = m_dlg_sciv.find('.compare-info-filter .filter');
					if( $ciff.length && $ciff.data('mj-widget') ) {
						var rst_filter_value = _before_page_change_query_vals.filter_value;
						// console.log({w:'AFTER .site-compare-select CHANGED -> SET filter',_before_page_change_query_vals,page_LOWER:Math.min(page_A,page_B),page_A,page_B});
						$ciff.mjWidget('set',rst_filter_value).mjWidget('trigger');
					}
				}, 12 );
			};

			function _parse_differences( x_page_A, x_page_B, j, ondone ) {

				// const x_page_lower = Math.min(x_page_A,x_page_B);
				const x_page_upper = Math.max(x_page_A,x_page_B);
				_before_page_change_query_vals.prev_page = _before_page_change_query_vals.page;
				// _before_page_change_query_vals.page = x_page_lower;
				_before_page_change_query_vals.page = x_page_upper;

				// console.log({w:'_parse_differences',j, x_page_A,x_page_B, _before_page_change_query_vals,page_LOWER:Math.min(page_A,page_B),page_A,page_B});

				var details, edi, ed;
				if( m_dlg_scedv===null ) return; // canceled (dialog was closed)
				m_dlg_scedv.removeClass('loading');

				if( j && j.hasOwnProperty('page_diffs') && j.page_diffs.hasOwnProperty(pd_key) ) {
					var pd = j.page_diffs[pd_key],
						overlays_a = [],
						overlays_b = [];
					var sc_info_text = '';
					if( pd.ndifferences==0 ) sc_info_text = mjt('mv-compare-c-info-diffs-0');
					else if( pd.ndifferences==1 ) sc_info_text = mjt('mv-compare-c-info-diffs-1');
					else sc_info_text = mjt('mv-compare-c-info-diffs-n').replace('%d',pd.ndifferences);
					m_dlg_sciv.html('<span class="site-compare-select compare-info-page-select"></span><span class="compare-info">'+sc_info_text+'</span><span class="compare-info-filter"><label>'+mjt('mv-compare-c-info-filter')+'</label><span class="filter"></span></span>');

					_destroy_connection_lines();
					m_dlg_overlays.empty();
					var pdedl = pd.elem_diffs.length;
					var element_types = {};
					if( !m_site_differences.hasOwnProperty(pd_key) ) {
						// m_site_differences[pd_key] = { page:0, ndiffs:0, inselect:false, textPage:'', textDiffs:'', textCombined:'', result:j };

						let tmp_page = x_page_upper;//Math.max(x_page_A,x_page_B);
						m_site_differences[pd_key] = _create_site_diff(j,tmp_page,pd_key);
					}

					const $scs = $('.site-compare-select',m_dlg);
					if( m_show_site_difference_select ) {

						// console.log({w:'.site-compare-select CREATE',has_$scs:!!($scs.length && $scs.data('mj-widget')),_before_page_change_query_vals,page_LOWER:Math.min(page_A,page_B),page_A,page_B});

						$scs.mjWidget({type:'list', 'default':_before_page_change_query_vals.page, addClass:'small', values:[['', '']], change: function() {
							var value = $(this).mjWidget('get');
							if( value!==null ) {
								const goto_page = parseInt(value);
								_before_page_change_query_vals.prev_page = _before_page_change_query_vals.page;
								_before_page_change_query_vals.page = goto_page;
								// _before_page_change_query_vals.filter_value = m_dlg_sciv.find('.compare-info-filter .filter').mjWidget('get');
								cv_A.mjMediaPageNavWidget('switchPage', goto_page, false, true);
								cv_B.mjMediaPageNavWidget('switchPage', goto_page, false, true);
							}
						} });
						// print_StructureCompare(null, _before_page_change_query_vals.page);
						// console.log({w:'_parse_differences > print_StructureCompare',_before_page_change_query_vals,x_page_A,x_page_B});
						print_StructureCompare(null,_before_page_change_query_vals.page);
						// $scs.mjWidget('set',_before_page_change_query_vals.page);

						// console.log({w:'.site-compare-select CREATE -> AFTER', page_value:$('.site-compare-select',m_dlg).data('mj-widget') ? $('.site-compare-select',m_dlg).mjWidget('get') : null });

					} else {
						$scs.hide();
					}

					for( edi=0; edi<pdedl; ++edi ) {
						ed = pd.elem_diffs[edi];
						if( ed.d!='B' ) overlays_a.push( { id:m_dlg_id+'-ed-a-'+edi, type:ed.t, bbox:ed.bbox_a } );
						if( ed.d!='A' ) overlays_b.push( { id:m_dlg_id+'-ed-b-'+edi, type:ed.t, bbox:ed.bbox_b } );

						var diff_elem = $('<div id="'+m_dlg_id+'-ed-'+edi+'" class="diff-elem-item">'
											+'<div class="diff-elem-item-idx">'+(edi+1)+')</div>'
											+'<div id="'+m_dlg_id+'-edx-'+edi+'" class="diff-elem-item-1 diff-type-'+ed.d+' md-sce-border-color-for-'+ed.t+'">'
												+'<div class="diff-elem-item-cmp link">&raquo; diff</div>'
												+'<div class="type"></div>'
											+'</div>'
										+'</div>')
							.data( {edi:edi,ed:ed,type:ed.t} )
							.attr( {element_type:ed.t })
							.appendTo(m_dlg_scedv);
						var diff_elem1 = diff_elem.children('div.diff-elem-item-1');

						var type_str = ed.t;
						if( ed.t=='text_run' ) type_str = mjt('mv-compare-c-type-text_run','!');
						else if( ed.t=='path' ) type_str = mjt('mv-compare-c-type-path','!');
						else if( ed.t=='image' ) type_str = mjt('mv-compare-c-type-image','!');
						else if( ed.t=='inline_image' ) type_str = mjt('mv-compare-c-type-inline_image','!');
						else if( ed.t=='shading' ) type_str = mjt('mv-compare-c-type-shading','!');
						var diff_elem1_type = diff_elem1.find('div.type').text(type_str);

						if( typeof element_types[ed.t] === 'undefined' ) element_types[ed.t] = { text:type_str, count:1 };
						else element_types[ed.t].count++;

						const full_details = m_option_values.hasOwnProperty('full_details') && m_option_values['full_details'];
						if( full_details ) {
							details = _create_diff_details_elem(ed);
							details.insertAfter(diff_elem1_type);
							diff_elem1.addClass('with-full-details');
						} else {
							details = $( '<div/>', { 'class':'details' } );
							details.insertAfter(diff_elem1_type);
						}

						if( ed.t=='text_run' ) {
							// with details for text differences...
							var diff_html = '';
							if( ed.d=='A' ) diff_html = '<del>'+htmlspecialchars(ed.content_a)+'</del>';
							else if( ed.d=='B' ) diff_html = '<ins>'+htmlspecialchars(ed.content_b)+'</ins>';
							else diff_html = htmldiff( text4htmldiff(ed.content_a), text4htmldiff(ed.content_b) );

							// details = $('<div class="details"></div>');
							$('<div class="text_run_diff"></div>').html(diff_html).appendTo(details);
							details.addClass('has-text_run_diff');
							// details.insertAfter(diff_elem1_type);

							diff_elem1.addClass('with-text-details');
						}
					}

					var filter_values = [['', '']];
					for( var property in element_types ) {
						if( element_types.hasOwnProperty(property) ) filter_values.push([property, element_types[property].text+' ('+element_types[property].count+')']);
					}

					var _apply_filter = function( filter_value ) {
						$('.diff-elem-item')
							.filter('.last').removeClass('last').end()
							.show();
						if( filter_value!==null && filter_value.length ) {
							$('.diff-elem-item[element_type!="'+filter_value+'"]').hide();
							$('.md-overlay-box').hide();
							$('.md-sce-border-color-for-'+filter_value).show();
						} else {
							$('.md-overlay-box').show();
						}
						$('.diff-elem-item')
							.filter(':visible')
							.last()
							.addClass('last');
					};

					m_dlg_sciv.find('.compare-info-filter .filter').mjWidget( {
						type: 'list',
						'default': _before_page_change_query_vals.filter_value,
						addClass: 'small',
						values: filter_values,
						change: function() {
							const filter_value = $(this).mjWidget('get');
							// console.log({w:'.compare-info-filter .filter CHANGED',filter_value,prev_val:_before_page_change_query_vals.filter_value});
							_before_page_change_query_vals.filter_value = filter_value;
							_apply_filter(filter_value);
							_select_elem_diff_by_idx(0,true);
						}
					} );
					_apply_filter(_before_page_change_query_vals.filter_value);

					// setup (visual) connections between elements ...
					for( edi=0; edi<pdedl; ++edi ) {
						ed = pd.elem_diffs[edi];
						connection_lines[edi] = [null,null];
						if( ed.d!='B' ) connection_lines[edi][0] = MVBoxCords.create( m_dlg_overlays, m_dlg_id+'-ed-a-'+edi, m_dlg_id+'-edx-'+edi, ed.t, false );
						if( ed.d!='A' ) connection_lines[edi][1] = MVBoxCords.create( m_dlg_overlays, m_dlg_id+'-edx-'+edi, m_dlg_id+'-ed-b-'+edi, ed.t, true );
					}
					m_dlg_scedv.off().scroll( function(e) {
						_update_connection_lines(selected_elem_diff_idx,selected_elem_diff_idx2);
					} );


					var _unselect_item_cmp = function( unselect_prev ) {
						if( m_dlg_scedv==null ) return;
						let cv_AandB = cv_A.add(cv_B);
						cv_AandB.find('.md-overlay-box').removeClass('highlighted-cmp');
						let $diff_elem_items = m_dlg_scedv.children('.diff-elem-item');
						$diff_elem_items.removeClass('highlighted-cmp');

						m_dlg_scedv.find('.diff-elem-item-cmp.emph').removeClass('emph');

						if( unselect_prev ) {
							m_prev_dd_edi = null;
							m_prev_dd_x = null;
							m_dlg_scedv.find('.diff-elem-item-cmp.disabled').removeClass('disabled');
						} else {
							m_dlg_scedv.find('.diff-elem-item-cmp').addClass('disabled');
						}
					};





					// setup connections visualizations.. (on mouseenter/mouseleave)
					m_dlg_scedv
						.on( 'click.mjMVCompare', '.diff-elem-item', function(e) {
							var self = $(this);
							var edi = self.data('edi');
							if( m_prev_dd_edi!==null && m_prev_dd_edi!=edi ) {
								self.find('.diff-elem-item-cmp').trigger('click');
								return false;
							}
							_unselect_item_cmp(true);
							_select_elem_diff_by_idx(edi,false);
						} )
						.on( 'click.mjMVCompare', '.diff-elem-item-cmp', function(e) {
							var btn = $(this);
							// var item1 = btn.closest('.diff-elem-item-1');
							var self = btn.closest('.diff-elem-item');
							var edi = self.data('edi');
							var ed = self.data('ed');
							var elem_edi = edi===null ? null : edi;
							var $elem = edi===null ? null : _get_elem_diff_by_idx(elem_edi);


							const edi_is_AB_item = ed.d!=='A' && ed.d!=='B';
							if( edi_is_AB_item ) {
								_unselect_item_cmp(true);
							}

							if( m_prev_dd_edi==edi ) {
								// no self-compare
								_unselect_item_cmp(true);
							} else {
								_unselect_item_cmp();

								if( $elem ) {
									// $elem
									// 	.add(_get_elem_diff_overlays_by_idx(elem_edi))
									// 	.addClass('highlighted');
									_select_elem_diff_by_idx(elem_edi,false);


									if( !edi_is_AB_item ) {
										let $tmp_candidates = m_dlg_scedv.children('.diff-elem-item[element_type="'+ed.t+'"]')
											.find('>.diff-type-A,>.diff-type-B')
											.find('>.diff-elem-item-cmp.disabled')
											.removeClass('disabled');
										$tmp_candidates.addClass('emph');
									}

									$elem.addClass('highlighted-cmp');
								}

								let $diff_html = null;
								if( edi_is_AB_item ) {
									// // eslint-disable-next-line no-console
									// console.log({w:'showing diff of '+ed.d+' item',ed});

									const dd = _get_diff_details_elem(elem_edi,ed);
									const dd_a = dd.a;
									const dd_b = dd.b;

									// console.log({w:' edi_is_AB_item',dd,dd_a,dd_b,ed});

									$diff_html = diff_details_html(dd_a,dd_b);

									let $diff_elem_item_cmp_elems = m_dlg_scedv.find('.diff-elem-item-cmp');
									$diff_elem_item_cmp_elems.filter('.emph').removeClass('emph');
									$diff_elem_item_cmp_elems.filter('.disabled').removeClass('disabled');

								} else {
									const dd = _get_diff_details_elem(elem_edi,ed);
									const dd_x = dd.diff_type==='B' ? dd.b : dd.a;

									// console.log({w:'!edi_is_AB_item',dd,dd_x,ed});

									if( m_prev_dd_x==null ) {
										m_prev_dd_edi = edi;
										m_prev_dd_x = dd_x;
										// if( window.MVPageDebug ) {
										// 	window.MVPageDebug.dprint_html( 'Entry Details', 'header', 'pre' );
										// 	window.MVPageDebug.dprint_html( htmlspecialchars(cur_details_diff_text,false,true), null, 'pre' );
										// }
									} else if( dd_x.type==m_prev_dd_x.type ) {

										var prev_elem_edi = m_prev_dd_edi===null ? null : m_prev_dd_edi;
										var $prev_elem = m_prev_dd_edi===null ? null : _get_elem_diff_by_idx(prev_elem_edi);

										if( $prev_elem ) {
											// $prev_elem
											// 	.add(_get_elem_diff_overlays_by_idx(prev_elem_edi))
											// 	.addClass('highlighted');
											_select_elem_diff_by_idx(prev_elem_edi,false,elem_edi);
											$prev_elem.addClass('highlighted-cmp');
										}

										if( dd.diff_type==='A' ) {
											$diff_html = diff_details_html(dd_x,m_prev_dd_x);
										} else {
											$diff_html = diff_details_html(m_prev_dd_x,dd_x);
										}

										m_prev_dd_x = null;
										m_prev_dd_edi = null;

										let $diff_elem_item_cmp_elems = m_dlg_scedv.find('.diff-elem-item-cmp');
										$diff_elem_item_cmp_elems.filter('.emph').removeClass('emph');
										$diff_elem_item_cmp_elems.filter('.disabled').removeClass('disabled');

									} else {

										// console.log({w:'type mismatch',m_prev_dd_x,dd_x});

										_unselect_item_cmp(true);

									}
								}

								if( $diff_html!=null ) {
									mjWidgetOverlayEditor.open(
										btn,
										$diff_html,
										function setup_cb( elem, val, ovl ) {
											// $('<div style="white-space:pre; font-family:monospace; padding: 6px 4px"></div>')
											// 	.html(val)
											// 	.appendTo(ovl);
											ovl.html(val);
										},
										null,
										null,
										function close_cb() {
											_unselect_item_cmp(true);
										},
										{
											'OverlayCssWidth':'auto',
											'OffsetParent':$('#page'),
											'GlobalOffset': true,
											'OverlayCss': {
												// 'margin-left': '-80px',
												'margin-top': '12px',
											},
											'FitOverlayIntoParent':true,
											'WrapOverlayContents':false,
											'OkButtonText':null,
											'CancelButtonText':null,
											OverlayDefaultFocused: true,
										}
									);
								}
							}

							return false;
						} );


					cv_A.triggerHandler('mjsoverlayssetup',[pd.info_a.media_box,pd.info_a.ref_box,overlays_a]);
					cv_B.triggerHandler('mjsoverlayssetup',[pd.info_b.media_box,pd.info_b.ref_box,overlays_b]);
					var cv_AandB = cv_A.add(cv_B);

					cv_AandB.on( 'mjsoverlaysdrawn.mjMVCompare', '.md-structure-overlays', function(e) {
						const filter_value = m_dlg_sciv.find('.compare-info-filter .filter').mjWidget('get');
						_apply_filter(filter_value);
						_select_elem_diff_by_idx(selected_elem_diff_idx,false,selected_elem_diff_idx2);
					} );

					_select_elem_diff_by_idx( pdedl>0 ? 0 : -1 );
				} else {
					var err_txt = mjt('mv-compare-mode-contents-failed','!');
					if( j && j.error ) err_txt += ' ('+j.error+')';
					else err_txt += ' (2)';
					setStatusText(err_txt);
				}

				if( ondone ) ondone();
			} // _parse_differences


			function _request_differences( ondone ) {
				_defered_lscd_timer = null;
				if( m_dlg_ddv===null ) return; // canceled (dialog was closed)
				// defer request ...
				if( m_site_differences.hasOwnProperty(pd_key) ) {
					_parse_differences(page_A,page_B,m_site_differences[pd_key].result,ondone);
				} else {
					if( page_A===page_B ) {
						if( m_last_callback_request!==null && m_last_callback_request.state && m_last_callback_request.state()==='pending' ) {
							if( _defered_lscd_timer ) clearTimeout(_defered_lscd_timer);
							_defered_lscd_timer = setTimeout( function() {
								_request_differences(ondone);
							}, 150 );
							return;
						}
					}
					if( m_last_ajax_request!==null && m_last_ajax_request.state && m_last_ajax_request.state()==='pending' ) {
						// ABORT pending request
						m_last_ajax_request.abort();
						m_last_ajax_request = null;
					}
					m_last_ajax_request = $.postJSON('json/media/structure-compare', postdata, function(j) {
						_parse_differences(page_A,page_B,j,ondone);
					} );
				}
			}

			// Quick & Dirty DEFER...
			// -> defer request to avoid duplicate requests to server
			if( _defered_lscd_timer ) clearTimeout(_defered_lscd_timer);
			_request_differences(ondone);
		} // _load_structure_compare_data




		MTemplates.queryTemplateHTML( 'fragment_media_toolbar_wrap', function(id,tb_html) {
			cv_A = m_dlg_left.show().children('.canvas');
			var tb_A = setupCompareItemToolbar(m_dlg_left,tb_html,m_media_id_A);

			cv_B = m_dlg_right.show().children('.canvas');
			var tb_B = setupCompareItemToolbar(m_dlg_right,tb_html,m_media_id_B);

			cv_A.mjMVComparePreview(
				{
					dtinfo:m_dtinfo_A,
					width:cv_A.innerWidth(),
					height:cv_A.innerHeight(),
					toolbar:tb_A[0],
					view_link_available:true,
					view_link_auto_on_count:2,
					view_link_group_pfx:'aLft_',
					setup_done:function(e) {
						if( ++_previews_setup_count === 2 ) {
							_previews_setup_done();
							_previews_setup_count = 0;
							if( _before_page_change_query_vals.page != 1 ) {
								// if( !cv_A.mjMediaPageNavWidget('instance') || !cv_B.mjMediaPageNavWidget('instance') ) {
								// 	// console.log({w:'deferSetup... 1'});
								// }
								cv_A.mjMediaPageNavWidget('switchPage', _before_page_change_query_vals.page, false, true);
								cv_B.mjMediaPageNavWidget('switchPage', _before_page_change_query_vals.page, false, true);
							}
						}
					},
				}
			);

			cv_B.mjMVComparePreview(
				{
					dtinfo:m_dtinfo_B,
					width:cv_B.innerWidth(),
					height:cv_B.innerHeight(),
					toolbar:tb_B[0],
					view_link_available:true,
					view_link_auto_on_count:2,
					view_link_group_pfx:'bRgt_',
					setup_done: function(e) {
						if( ++_previews_setup_count === 2 ) {
							_previews_setup_done();
							_previews_setup_count = 0;
							if( _before_page_change_query_vals.page != 1 ) {
								// if( !cv_A.mjMediaPageNavWidget('instance') || !cv_B.mjMediaPageNavWidget('instance') ) {
								// 	// console.log({w:'deferSetup... 2'});
								// }
								cv_A.mjMediaPageNavWidget('switchPage', _before_page_change_query_vals.page, false, true);
								cv_B.mjMediaPageNavWidget('switchPage', _before_page_change_query_vals.page, false, true);
							}
						}
					},
				}
			);

			// keyboard navigation handler ...
			$(document).off('keydown.mjMVCompare').on('keydown.mjMVCompare', function(e) {
				var visible_diff_elems = m_dlg_scedv.children('.diff-elem-item:visible');
				if( visible_diff_elems.length>1 ) {
					// handle navigation keys
					switch( e.which ) {
					case 33: // PageUp
						_select_elem_diff_by_idx( -5, true );
						return false;
					case 38: // UP
						_select_elem_diff_by_idx( -1, true );
						return false;
					case 34: // PageDown
						_select_elem_diff_by_idx( +5, true );
						return false;
					case 40: // DOWN
						_select_elem_diff_by_idx( +1, true );
						return false;
					case 36: // POS1
						_select_elem_diff_by_idx( visible_diff_elems.first().data('edi') );
						return false;
					case 35: // END
						_select_elem_diff_by_idx( visible_diff_elems.last().data('edi') );
						return false;
					}
				}
				return true;
			} );

		} ); // MTemplates.queryTemplateHTML( 'fragment_media_toolbar_wrap', function(id,tb_html) {

	} // setupCompareView_Contents()


	function isCanvasSupported() {
		if( document.createElement('canvas').getContext ) {
			// TODO: check whether ctx.getImageData() & ctx.createImageData() are supported too ???
			//       => these are required, and not available on any canvas-enabled UA !? :/
			return true;
		}
		return false;
	}

	function setupCompareView_for_mode( mode, initialJumpToPage ) {
		if( typeof initialJumpToPage === 'undefined' ) initialJumpToPage = 1;

		// console.log({w:'setupCompareView_for_mode',mode,initialJumpToPage});

		// cleanup all mode-specific elements...
		_cleanup_mode();
		// tabs...
		m_mode = mode;
		m_dlg_tabs.mjDialogTabs('activate',m_mode);
		// dlg contents...
		setStatusText(m_px2px_status_text);
		switch( m_mode ) {
		case 'side-by-side':
			setupCompareView_SideBySide();
			break;
		case 'px2px-onion-skin':
			setupCompareView_Px2Px( _setupCompareView_Px2PxOnionSkin_mjsresize, initialJumpToPage );
			break;
		case 'px2px-diff':
			if( isCanvasSupported() ) {
				setupCompareView_Px2Px( _setupCompareView_Px2PxDiff_mjsresize, initialJumpToPage );
			} else {
				setStatusText(mjt('mv-compare-mode-px2px-modern-ua-required','!'));
			}
			break;
		case 'contents':
			setupCompareView_Contents(initialJumpToPage);
			break;
		}
	}

	function setStatusText( text ) {
		var status_elem = m_dlg_menu.find('.status').filter(':visible').empty();
		if( status_elem.length===0 ) {
			if( m_dlg_tabs!==null ) m_dlg_tabs.mjDialogTabs('status',text);
		} else if( text.length>0 ) {
			$('<span></span>').text(text).appendTo( status_elem );
		}
	}

	function isAdvancedCompareContentsModePossible( dtinfo ) {
		const media_class = dtinfo.meta[-1] ? dtinfo.meta[-1][0] : 0;
		if( media_class!=4 ) {
			return false;
		}
		const media_type = dtinfo.meta[-2] ? dtinfo.meta[-2][0] : 'application/octet-stream';

		// PDF
		if( media_type==='application/pdf' ) return true;

		// Various Office Types
		// .doc
		if( media_type==='application/msword' ) return true;
		// .docx
		if( media_type==='application/vnd.openxmlformats-officedocument.wordprocessingml.document' ) return true;

		// .xls
		if( media_type==='application/vnd.ms-excel' ) return true;
		// .xlsx
		if( media_type==='application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ) return true;

		// .ppt
		if( media_type==='application/mspowerpoint' ) return true;
		// .pptx
		if( media_type==='application/vnd.openxmlformats-officedocument.presentationml.presentation' ) return true;

		return false;
	}

	function openCompareView( set_to_mode ) {
		_setup_dlg();
		// determine modes, that are available for current selection
		var px2px_modes_enabled = false,
			mc_A = m_dtinfo_A.meta[-1] ? m_dtinfo_A.meta[-1][0] : 0,
			mc_B = m_dtinfo_B.meta[-1] ? m_dtinfo_B.meta[-1][0] : 0,
			has_cp_A = m_dtinfo_A.meta[12] && m_dtinfo_A.meta[12][0].length>0,
			has_cp_B = m_dtinfo_B.meta[12] && m_dtinfo_B.meta[12][0].length>0;
		m_px2px_status_text = '';
		if( (mc_A==1||mc_A==4) && (mc_B==1||mc_B==4) ) {
			// both are either MC_IMAGE or MC_TEXT
			if( has_cp_A || has_cp_B ) {
				// no pixel compare, if one has custom preview
				//...
			} else {
				if( m_dim_A[0]!=0 && m_dim_A[1]!=0 && m_dim_A[0]==m_dim_B[0] && m_dim_A[1]==m_dim_B[1] ) {
					// both have same dimensions
					px2px_modes_enabled = true;
				} else if( m_dim_A[0]==0 && m_dim_A[1]==0 && m_dim_B[0]==0 && m_dim_B[1]==0 && _nearly_equal_aspect(m_dim_A[4],m_dim_B[4]) ) {
					// both have NO dimension, but both have very similar aspect ratios
					px2px_modes_enabled = true;
				} else if( ( (m_dim_A[0]==0 && m_dim_A[1]==0) || (m_dim_B[0]==0 && m_dim_B[1]==0) ) && _nearly_equal_aspect(m_dim_A[4],m_dim_B[4]) ) {
					// one has no dimensions, but both have very similar aspect ratios
					// TODO: query missing dimensions, if possible...
					px2px_modes_enabled = true;
					m_px2px_status_text = mjt('mv-compare-mode-px2px-different-dimensions','!');
				} else if( _nearly_equal_aspect(m_dim_A[4],m_dim_B[4]) ) {
					// different dimensions, but aspect ratios are similar...
					// TODO: query missing dimensions, if possible...
					px2px_modes_enabled = true;
					m_px2px_status_text = mjt('mv-compare-mode-px2px-different-dimensions','!');
				} else {
					m_px2px_status_text = mjt('mv-compare-mode-px2px-different-dimensions-px2px-not-available','!');
				}
				//if( px2px_modes_enabled ) {
				// add warning if page count of the assets differs...
				var pi_A = _get_pi_from_meta(m_dtinfo_A),
					pi_B = _get_pi_from_meta(m_dtinfo_B);
				if( !pi_A[1] && !pi_B[1] ) {
					// exact page count of both assets is known...
					if( pi_A[0] != pi_B[0] ) {
						// page count differs...
						if( m_px2px_status_text=='' ) m_px2px_status_text = mjt('mv-compare-mode-px2px-different-page-count','!');
					}
				} else if( pi_A[1] || pi_B[1] ) {
					// page count of one (or both) of the assets is actually unknown...
					if( m_px2px_status_text=='' ) m_px2px_status_text = mjt('mv-compare-mode-px2px-maybe-different-page-count','!');
				}
				//}
			}
		}

		if( !px2px_modes_enabled ) {
			if( m_px2px_status_text=='' ) m_px2px_status_text = mjt('mv-compare-mode-px2px-not-available','!');
		}
		if( m_px2px_status_text!='' ) setStatusText(m_px2px_status_text);

		m_contents_mode_enabled = false;
		if( mj.feature_advanced_compare ) {
			m_contents_mode_enabled = isAdvancedCompareContentsModePossible(m_dtinfo_A) && isAdvancedCompareContentsModePossible(m_dtinfo_B);
		}


		var mode_tabs = [ { id:'side-by-side', html:'<span id="mv-compare-mode-link-side-by-side" class="link" tabindex="0" role="button">'+mjt('mv-compare-mode-side-by-side','!')+'</span>' } ];

		// TODO: use tabs with "disabled" state (...helps users to actually find the functions...)

		if( px2px_modes_enabled ) {
			mode_tabs.push( { id:'px2px-onion-skin',	html:'<span id="mv-compare-mode-link-px2px-onion-skin" class="link" tabindex="0" role="button">'+mjt('mv-compare-mode-px2px-onion-skin','!')+'</span>' } );
			mode_tabs.push( { id:'px2px-diff',			html:'<span id="mv-compare-mode-link-px2px-diff" class="link" tabindex="0" role="button">'+mjt('mv-compare-mode-px2px-diff','!')+'</span>' } );
		}
		if( m_contents_mode_enabled ) {
			mode_tabs.push( { id:'contents',			html:'<span id="mv-compare-mode-link-contents" class="link" tabindex="0" role="button">'+mjt('mv-compare-mode-contents','!')+'</span>' } );
		}

		var found_mode = false;
		for( var mi=0; mi<mode_tabs.length; ++mi ) {
			if( mode_tabs[mi].id===set_to_mode ) {
				m_mode = set_to_mode;
				found_mode = true;
				break;
			}
		}
		if( !found_mode ) m_mode = mode_tabs[0].id;

		m_dlg_tabs = m_dlg.closest('.ui-dialog').find('> .ui-dialog-titlebar > .ui-dialog-title')
			.mjDialogTabs( { tabs:mode_tabs } )
			.mjDialogTabs('activate',m_mode)
			.find('#mv-compare-mode-link-side-by-side').click( function() {
				setupCompareView_for_mode('side-by-side');
			} ).end()
			.find('#mv-compare-mode-link-px2px-onion-skin').click( function() {
				setupCompareView_for_mode('px2px-onion-skin');
			} ).end()
			.find('#mv-compare-mode-link-px2px-diff').click( function() {
				setupCompareView_for_mode('px2px-diff');
			} ).end()
			.find('#mv-compare-mode-link-contents').click( function() {
				setupCompareView_for_mode('contents');
			} ).end()
			.find('#mv-compare-mode-link-complete-contents').click( function() {
				setupCompareView_for_mode('complete_contents');
			} ).end()
		;
		// setup view in current mode...
		setupCompareView_for_mode(m_mode);
		// show the dialog...
		m_dlg.show();
	}

	function loadCompareViewData() {
		var _on_data1 = function() {
			m_dim_A = _get_dim_from_meta(m_dtinfo_A);
			m_dim_B = _get_dim_from_meta(m_dtinfo_B);
			stopProgress();
			openCompareView(m_mode);
		};
		// get detail infos
		startProgress();
		MDMedia.queryMediaDetailVersionInfo( m_media_id_A, m_version_A, function( dtinfo ) {
			m_dtinfo_A = mj_deep_extend({},dtinfo);
			if( m_dtinfo_B!==null ) _on_data1();
		}, default_ajax_app_error_handler, true );
		MDMedia.queryMediaDetailVersionInfo( m_media_id_B, m_version_B, function( dtinfo ) {
			m_dtinfo_B = mj_deep_extend({},dtinfo);
			if( m_dtinfo_A!==null ) _on_data1();
		}, default_ajax_app_error_handler, true );
	}

	function selectItem( media_id, version, show_dialog ) {

		m_mode = 'side-by-side';

		if( m_media_id_A===null ) {
			m_media_id_A = media_id;
			m_version_A = version;
			updateIndicatorView(show_dialog);
		} else if( show_dialog ) {
			if( media_id===m_media_id_A && version===m_version_A ) {
				// no compare to self...
			} else {
				m_media_id_B = media_id;
				m_version_B = version;
				updateIndicatorView(show_dialog);
				loadCompareViewData();
			}
		} else {
			m_media_id_A = media_id;
			m_version_A = version;
			updateIndicatorView(show_dialog);
		}
	}

	function startCompare( media_id_A, version_A, media_id_B, version_B ) {
		reset(false);
		selectItem(media_id_A,version_A,false);
		selectItem(media_id_B,version_B,true);
	}

	$(document).one('mjsload',function() {
		m_options = {
			'detect_relocated_elements':                      { label:mjt('mv-compare-c-opt-detect_relocated_elements'),						def:true,		enables:['detect_relocated_elements_scaled_to_page_size'] },
			'detect_relocated_elements_scaled_to_page_size':  { label:mjt('mv-compare-c-opt-detect_relocated_elements_scaled_to_page_size'),	def:true		},
			'colors_in_24bit_DeviceRGB':         { label:mjt('mv-compare-c-opt-colors_in_24bit_DeviceRGB'),			def: true },
			//'fuzzy_colors':                    { label:mjt('mv-compare-c-opt-fuzzy_colors'),						def: true },
			'ignore_fonts':                      { label:mjt('mv-compare-c-opt-ignore_fonts'),						def: true },
			//'fuzzy_font_sizes':                { label:mjt('mv-compare-c-opt-fuzzy_font_sizes'),					def:false },
			//'relaxed_winding_rules':           { label:mjt('mv-compare-c-opt-relaxed_winding_rules'),				def: true },
			'image_colors_in_24bit_DeviceRGB':   { label:mjt('mv-compare-c-opt-image_colors_in_24bit_DeviceRGB'),	def:true },
			//'ignore_empty_text_runs':          { label:mjt('mv-compare-c-opt-ignore_empty_text_runs'),			def: true },
			'individual_text_lines':             { label:mjt('mv-compare-c-opt-individual_text_lines'),				def: true },
			'full_details':                      { label:mjt('mv-compare-c-opt-full_details'),						def: false},
		};
		var tmp = getFromSession('compare_item_A','');
		if( tmp ) {
			tmp = split_once(tmp,':');
			if( tmp[0] ) selectItem(tmp[0],tmp.length>1?tmp[1]||null:null,false);
		}
	});


	/**
	 * Compare Preview ( .mjMVComparePreview )
	 * usage:
	 *  $('#container').mjMVComparePreview( { dtinfo:dtinfo, width:w, height:h, toolbar:toolbar_dom_elem } )
	 */
	mjRegisterSimpleJQueryPlugin($,'mjMVComparePreview',{
		init: function( opts ) {
			var target_elem = this;
			opts.preview_loader = MPreviewUtil.createMediaPreviewLoader(1500);
			$(this)
				.data('mj-mv-compare-preview',opts)
				.html('<img src="'+htmlspecialchars(mj.skin_files['ajax-loader'],true,true)+'" style="vertical-align:middle" />');

			// setup new preview on canvas & setup toolbar
			var xopts = {
				//??//view_session_pfx: 'mdc_',
				default_pdf_viewer_type: 'manja',
			};
			if( opts.hasOwnProperty('view_link_available') ) xopts.view_link_available = opts.view_link_available;
			if( opts.hasOwnProperty('view_link_auto_on_count') ) xopts.view_link_auto_on_count = opts.view_link_auto_on_count;
			if( opts.hasOwnProperty('view_link_group_pfx') ) xopts.view_link_group_pfx = opts.view_link_group_pfx;

			opts.preview_loader.onAfterCreatePreview( function( dtinfo, target_elem, xopts, toolbar_elem ) {
				$(target_elem).triggerHandler('mjsshow');
				if( opts.setup_done ) opts.setup_done();
			} );
			opts.preview_loader.createPreviewWhenMediaPreviewAvailable(opts.dtinfo,target_elem,xopts,opts.toolbar||null);
		},
		destroy: function() {
			var opts = $(this).data('mj-mv-compare-preview');
			if( opts && opts.preview_loader ) {
				opts.preview_loader.removePreview();
			}
			$(this).removeData(['mj-mv-compare-preview']);
		},
	});

	return {
		selectItem:		MTemplates.queryDialogHTMLWrappedFn('form_media_compare',selectItem),
		startCompare:	MTemplates.queryDialogHTMLWrappedFn('form_media_compare',startCompare),
		hide:			MTemplates.queryDialogHTMLWrappedFn('form_media_compare',_destroy_dlg),
	};

}(jQuery,mj); // namespace MVCompare
